// source: buying/auctions/api/v1/types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var buying_achievement_tickets_types_v1_types_pb = require('../../../../buying/achievement_tickets/types/v1/types_pb.js');
goog.object.extend(proto, buying_achievement_tickets_types_v1_types_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.buying.auctions.api.v1.AdpAsset', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.AdpAssetType', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ApprovalStatus', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.Auction', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.AuctionApplicant', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.AuctionCompletionType', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.AuctionEventType', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.AuctionState', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ClearAuctionsRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ClearAuctionsResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.CreateAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.CreateAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.DeleteAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.DeleteAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.EnterAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.EnterAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.EntryTickets', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserAuctionsRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserAuctionsResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserPrizesRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.GetUserPrizesResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListAuctionApplicantsRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListAuctionApplicantsResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListAuctionsRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListAuctionsResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListMarkedBiddersRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ListMarkedBiddersResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.MarkBidderRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.MarkBidderResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.MediaAsset', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.Money', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.Prize', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.PrizeStatus', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ProcessWinnersRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.ProcessWinnersResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.SetApprovalStatusRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.SetApprovalStatusResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.TransparentAsset', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UnmarkBidderRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UnmarkBidderResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UpdateAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UpdateAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UpdateBidRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UpdateBidResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UserAuction', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UserEnteredAuctionRequest', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.UserEnteredAuctionResponse', null, global);
goog.exportSymbol('proto.buying.auctions.api.v1.WinnerPrize', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.MediaAsset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.MediaAsset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.MediaAsset.displayName = 'proto.buying.auctions.api.v1.MediaAsset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.TransparentAsset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.TransparentAsset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.TransparentAsset.displayName = 'proto.buying.auctions.api.v1.TransparentAsset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.EntryTickets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.EntryTickets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.EntryTickets.displayName = 'proto.buying.auctions.api.v1.EntryTickets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.AdpAsset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.AdpAsset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.AdpAsset.displayName = 'proto.buying.auctions.api.v1.AdpAsset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.Money = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.Money, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.Money.displayName = 'proto.buying.auctions.api.v1.Money';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.Prize = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.Prize, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.Prize.displayName = 'proto.buying.auctions.api.v1.Prize';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UserAuction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.UserAuction.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.UserAuction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UserAuction.displayName = 'proto.buying.auctions.api.v1.UserAuction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserAuctionRequest.displayName = 'proto.buying.auctions.api.v1.GetUserAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserAuctionResponse.displayName = 'proto.buying.auctions.api.v1.GetUserAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.GetUserAuctionsRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserAuctionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserAuctionsRequest.displayName = 'proto.buying.auctions.api.v1.GetUserAuctionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.GetUserAuctionsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserAuctionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserAuctionsResponse.displayName = 'proto.buying.auctions.api.v1.GetUserAuctionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.EnterAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.EnterAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.EnterAuctionRequest.displayName = 'proto.buying.auctions.api.v1.EnterAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.EnterAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.EnterAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.EnterAuctionResponse.displayName = 'proto.buying.auctions.api.v1.EnterAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.displayName = 'proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.displayName = 'proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UpdateBidRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UpdateBidRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UpdateBidRequest.displayName = 'proto.buying.auctions.api.v1.UpdateBidRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UpdateBidResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UpdateBidResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UpdateBidResponse.displayName = 'proto.buying.auctions.api.v1.UpdateBidResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UserEnteredAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UserEnteredAuctionRequest.displayName = 'proto.buying.auctions.api.v1.UserEnteredAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UserEnteredAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UserEnteredAuctionResponse.displayName = 'proto.buying.auctions.api.v1.UserEnteredAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserPrizesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserPrizesRequest.displayName = 'proto.buying.auctions.api.v1.GetUserPrizesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.GetUserPrizesResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetUserPrizesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetUserPrizesResponse.displayName = 'proto.buying.auctions.api.v1.GetUserPrizesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.Auction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.Auction.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.Auction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.Auction.displayName = 'proto.buying.auctions.api.v1.Auction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.CreateAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.CreateAuctionRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.CreateAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.CreateAuctionRequest.displayName = 'proto.buying.auctions.api.v1.CreateAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.CreateAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.CreateAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.CreateAuctionResponse.displayName = 'proto.buying.auctions.api.v1.CreateAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetAuctionRequest.displayName = 'proto.buying.auctions.api.v1.GetAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.GetAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.GetAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.GetAuctionResponse.displayName = 'proto.buying.auctions.api.v1.GetAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.UpdateAuctionRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.UpdateAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UpdateAuctionRequest.displayName = 'proto.buying.auctions.api.v1.UpdateAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UpdateAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UpdateAuctionResponse.displayName = 'proto.buying.auctions.api.v1.UpdateAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.DeleteAuctionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.DeleteAuctionRequest.displayName = 'proto.buying.auctions.api.v1.DeleteAuctionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.DeleteAuctionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.DeleteAuctionResponse.displayName = 'proto.buying.auctions.api.v1.DeleteAuctionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListAuctionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListAuctionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListAuctionsRequest.displayName = 'proto.buying.auctions.api.v1.ListAuctionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListAuctionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.ListAuctionsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListAuctionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListAuctionsResponse.displayName = 'proto.buying.auctions.api.v1.ListAuctionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ClearAuctionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ClearAuctionsRequest.displayName = 'proto.buying.auctions.api.v1.ClearAuctionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ClearAuctionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ClearAuctionsResponse.displayName = 'proto.buying.auctions.api.v1.ClearAuctionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.MarkBidderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.MarkBidderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.MarkBidderRequest.displayName = 'proto.buying.auctions.api.v1.MarkBidderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.MarkBidderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.MarkBidderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.MarkBidderResponse.displayName = 'proto.buying.auctions.api.v1.MarkBidderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UnmarkBidderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UnmarkBidderRequest.displayName = 'proto.buying.auctions.api.v1.UnmarkBidderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.UnmarkBidderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.UnmarkBidderResponse.displayName = 'proto.buying.auctions.api.v1.UnmarkBidderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListMarkedBiddersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListMarkedBiddersRequest.displayName = 'proto.buying.auctions.api.v1.ListMarkedBiddersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.ListMarkedBiddersResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListMarkedBiddersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListMarkedBiddersResponse.displayName = 'proto.buying.auctions.api.v1.ListMarkedBiddersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.WinnerPrize = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.WinnerPrize, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.WinnerPrize.displayName = 'proto.buying.auctions.api.v1.WinnerPrize';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.ProcessWinnersRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.ProcessWinnersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ProcessWinnersRequest.displayName = 'proto.buying.auctions.api.v1.ProcessWinnersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ProcessWinnersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ProcessWinnersResponse.displayName = 'proto.buying.auctions.api.v1.ProcessWinnersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.displayName = 'proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.displayName = 'proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.SetApprovalStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.SetApprovalStatusRequest.displayName = 'proto.buying.auctions.api.v1.SetApprovalStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.SetApprovalStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.SetApprovalStatusResponse.displayName = 'proto.buying.auctions.api.v1.SetApprovalStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.AuctionApplicant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.AuctionApplicant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.AuctionApplicant.displayName = 'proto.buying.auctions.api.v1.AuctionApplicant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListAuctionApplicantsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.displayName = 'proto.buying.auctions.api.v1.ListAuctionApplicantsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.repeatedFields_, null);
};
goog.inherits(proto.buying.auctions.api.v1.ListAuctionApplicantsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.displayName = 'proto.buying.auctions.api.v1.ListAuctionApplicantsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.MediaAsset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.MediaAsset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MediaAsset.toObject = function(includeInstance, msg) {
  var f, obj = {
imageUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
videoUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.MediaAsset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.MediaAsset;
  return proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.MediaAsset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.MediaAsset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string image_url = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.MediaAsset} returns this
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string video_url = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.getVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.MediaAsset} returns this
 */
proto.buying.auctions.api.v1.MediaAsset.prototype.setVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.TransparentAsset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.TransparentAsset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.TransparentAsset.toObject = function(includeInstance, msg) {
  var f, obj = {
movUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
webmUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.TransparentAsset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.TransparentAsset;
  return proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.TransparentAsset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMovUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebmUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.TransparentAsset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMovUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWebmUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string mov_url = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.getMovUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.TransparentAsset} returns this
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.setMovUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string webm_url = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.getWebmUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.TransparentAsset} returns this
 */
proto.buying.auctions.api.v1.TransparentAsset.prototype.setWebmUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.EntryTickets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.EntryTickets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EntryTickets.toObject = function(includeInstance, msg) {
  var f, obj = {
ticketType: jspb.Message.getFieldWithDefault(msg, 1, 0),
ticketCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.EntryTickets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.EntryTickets;
  return proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.EntryTickets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.achievement_tickets.types.v1.AchievementTicketType} */ (reader.readEnum());
      msg.setTicketType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTicketCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.EntryTickets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTicketCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional buying.achievement_tickets.types.v1.AchievementTicketType ticket_type = 1;
 * @return {!proto.buying.achievement_tickets.types.v1.AchievementTicketType}
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.getTicketType = function() {
  return /** @type {!proto.buying.achievement_tickets.types.v1.AchievementTicketType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.achievement_tickets.types.v1.AchievementTicketType} value
 * @return {!proto.buying.auctions.api.v1.EntryTickets} returns this
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.setTicketType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 ticket_count = 2;
 * @return {number}
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.getTicketCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.EntryTickets} returns this
 */
proto.buying.auctions.api.v1.EntryTickets.prototype.setTicketCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.AdpAsset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.AdpAsset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.AdpAsset.toObject = function(includeInstance, msg) {
  var f, obj = {
isMainAsset: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
assetType: jspb.Message.getFieldWithDefault(msg, 2, 0),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
usdzUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
glbUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
movUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
webmUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
imageUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
mp4Url: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.AdpAsset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.AdpAsset;
  return proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.AdpAsset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMainAsset(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.auctions.api.v1.AdpAssetType} */ (reader.readEnum());
      msg.setAssetType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsdzUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGlbUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMovUrl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebmUrl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMp4Url(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.AdpAsset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsMainAsset();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAssetType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsdzUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGlbUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMovUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWebmUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMp4Url();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional bool is_main_asset = 1;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getIsMainAsset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setIsMainAsset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional AdpAssetType asset_type = 2;
 * @return {!proto.buying.auctions.api.v1.AdpAssetType}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getAssetType = function() {
  return /** @type {!proto.buying.auctions.api.v1.AdpAssetType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AdpAssetType} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string thumbnail_url = 3;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string usdz_url = 4;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getUsdzUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setUsdzUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string glb_url = 5;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getGlbUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setGlbUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string mov_url = 6;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getMovUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setMovUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string webm_url = 7;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getWebmUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setWebmUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string image_url = 8;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string mp4_url = 9;
 * @return {string}
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.getMp4Url = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AdpAsset} returns this
 */
proto.buying.auctions.api.v1.AdpAsset.prototype.setMp4Url = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.Money.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.Money.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.Money} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Money.toObject = function(includeInstance, msg) {
  var f, obj = {
currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
amountUsdCents: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.Money}
 */
proto.buying.auctions.api.v1.Money.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.Money;
  return proto.buying.auctions.api.v1.Money.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.Money} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.Money}
 */
proto.buying.auctions.api.v1.Money.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountUsdCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.Money.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.Money.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.Money} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Money.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAmountUsdCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.Money.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Money} returns this
 */
proto.buying.auctions.api.v1.Money.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.buying.auctions.api.v1.Money.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Money} returns this
 */
proto.buying.auctions.api.v1.Money.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 amount_usd_cents = 3;
 * @return {number}
 */
proto.buying.auctions.api.v1.Money.prototype.getAmountUsdCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Money} returns this
 */
proto.buying.auctions.api.v1.Money.prototype.setAmountUsdCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.Prize.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.Prize.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.Prize} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Prize.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
auctionName: jspb.Message.getFieldWithDefault(msg, 2, ""),
lotNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
productId: jspb.Message.getFieldWithDefault(msg, 4, ""),
imageAssetUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
statusUpdatedAt: (f = msg.getStatusUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
expireInSeconds: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.Prize}
 */
proto.buying.auctions.api.v1.Prize.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.Prize;
  return proto.buying.auctions.api.v1.Prize.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.Prize} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.Prize}
 */
proto.buying.auctions.api.v1.Prize.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLotNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageAssetUrl(value);
      break;
    case 6:
      var value = /** @type {!proto.buying.auctions.api.v1.PrizeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStatusUpdatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpireInSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.Prize.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.Prize.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.Prize} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Prize.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuctionName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLotNumber();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImageAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStatusUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpireInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.Prize.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string auction_name = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.Prize.prototype.getAuctionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setAuctionName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 lot_number = 3;
 * @return {number}
 */
proto.buying.auctions.api.v1.Prize.prototype.getLotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setLotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string product_id = 4;
 * @return {string}
 */
proto.buying.auctions.api.v1.Prize.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string image_asset_url = 5;
 * @return {string}
 */
proto.buying.auctions.api.v1.Prize.prototype.getImageAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setImageAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional PrizeStatus status = 6;
 * @return {!proto.buying.auctions.api.v1.PrizeStatus}
 */
proto.buying.auctions.api.v1.Prize.prototype.getStatus = function() {
  return /** @type {!proto.buying.auctions.api.v1.PrizeStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.PrizeStatus} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp status_updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Prize.prototype.getStatusUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
*/
proto.buying.auctions.api.v1.Prize.prototype.setStatusUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.clearStatusUpdatedAt = function() {
  return this.setStatusUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Prize.prototype.hasStatusUpdatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 expire_in_seconds = 8;
 * @return {number}
 */
proto.buying.auctions.api.v1.Prize.prototype.getExpireInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Prize} returns this
 */
proto.buying.auctions.api.v1.Prize.prototype.setExpireInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.UserAuction.repeatedFields_ = [2,5,42,47,56,59,61,69];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UserAuction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UserAuction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserAuction.toObject = function(includeInstance, msg) {
  var f, obj = {
preStartTime: (f = msg.getPreStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
roundStartTimesList: jspb.Message.toObjectList(msg.getRoundStartTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
itemFacts: jspb.Message.getFieldWithDefault(msg, 4, ""),
entryTicketsList: jspb.Message.toObjectList(msg.getEntryTicketsList(),
    proto.buying.auctions.api.v1.EntryTickets.toObject, includeInstance),
minimumBidAmountCents: jspb.Message.getFieldWithDefault(msg, 6, 0),
auctionVideoUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
auctionAudioUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
auctionBackgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
auctionAudioTrackUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
itemImageUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
itemVideoUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
item3dAssetUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
userBidSoundUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
bidSubmittedSoundUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
productTemplateName: jspb.Message.getFieldWithDefault(msg, 16, ""),
productSizeUs: jspb.Message.getFieldWithDefault(msg, 17, ""),
releaseYear: jspb.Message.getFieldWithDefault(msg, 18, ""),
itemStory: jspb.Message.getFieldWithDefault(msg, 19, ""),
numParticipants: jspb.Message.getFieldWithDefault(msg, 20, 0),
auctionAsset: (f = msg.getAuctionAsset()) && proto.buying.auctions.api.v1.MediaAsset.toObject(includeInstance, f),
ticketEntryUnlocked: (f = msg.getTicketEntryUnlocked()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
ticketsUnlocked: (f = msg.getTicketsUnlocked()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lockedOut: (f = msg.getLockedOut()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
auctionState: jspb.Message.getFieldWithDefault(msg, 25, 0),
estimatedValue: jspb.Message.getFieldWithDefault(msg, 26, ""),
waitingRoomAudioUrl: jspb.Message.getFieldWithDefault(msg, 27, ""),
itemAudioUrl: jspb.Message.getFieldWithDefault(msg, 28, ""),
userJoinedSoundUrl: jspb.Message.getFieldWithDefault(msg, 29, ""),
auctionId: jspb.Message.getFieldWithDefault(msg, 30, ""),
winnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 31, ""),
topFiveShareImageUrl: jspb.Message.getFieldWithDefault(msg, 32, ""),
nonWinnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 33, ""),
storyLengthSeconds: jspb.Message.getFieldWithDefault(msg, 34, 0),
storyStartTime: (f = msg.getStoryStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
userJoined: (f = msg.getUserJoined()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
shareText: jspb.Message.getFieldWithDefault(msg, 37, ""),
shareLink: jspb.Message.getFieldWithDefault(msg, 38, ""),
transparentAsset: (f = msg.getTransparentAsset()) && proto.buying.auctions.api.v1.TransparentAsset.toObject(includeInstance, f),
maximumParticipants: jspb.Message.getFieldWithDefault(msg, 40, 0),
preRegistrationTime: (f = msg.getPreRegistrationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
maxBidCapCentsList: (f = jspb.Message.getRepeatedField(msg, 42)) == null ? undefined : f,
isWatcher: (f = msg.getIsWatcher()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotNumber: jspb.Message.getFieldWithDefault(msg, 44, 0),
lobbyStartTime: (f = msg.getLobbyStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
ultimateEndTime: (f = msg.getUltimateEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lobbyRoundTransitionTimesList: jspb.Message.toObjectList(msg.getLobbyRoundTransitionTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
productCondition: jspb.Message.getFieldWithDefault(msg, 48, ""),
productSellerName: jspb.Message.getFieldWithDefault(msg, 49, ""),
isAbsenteeAuction: (f = msg.getIsAbsenteeAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
brandName: jspb.Message.getFieldWithDefault(msg, 51, ""),
isPublished: (f = msg.getIsPublished()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
eventTime: (f = msg.getEventTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
minEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 54, 0),
maxEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 55, 0),
adpAssetsList: jspb.Message.toObjectList(msg.getAdpAssetsList(),
    proto.buying.auctions.api.v1.AdpAsset.toObject, includeInstance),
localizedMinEstimatedValue: (f = msg.getLocalizedMinEstimatedValue()) && proto.buying.auctions.api.v1.Money.toObject(includeInstance, f),
localizedMaxEstimatedValue: (f = msg.getLocalizedMaxEstimatedValue()) && proto.buying.auctions.api.v1.Money.toObject(includeInstance, f),
maximumRoundWinnersList: (f = jspb.Message.getRepeatedField(msg, 59)) == null ? undefined : f,
timeExpiringSoundUrl: jspb.Message.getFieldWithDefault(msg, 60, ""),
absenteeAuctionProductIdsList: (f = jspb.Message.getRepeatedField(msg, 61)) == null ? undefined : f,
enteredUserCount: jspb.Message.getFieldWithDefault(msg, 62, 0),
paymentRegistrationEnabled: (f = msg.getPaymentRegistrationEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
segmentId: jspb.Message.getFieldWithDefault(msg, 64, ""),
isBlackFridayAuction: (f = msg.getIsBlackFridayAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
currentHighestBidCents: jspb.Message.getFieldWithDefault(msg, 66, 0),
userBidAmountCents: jspb.Message.getFieldWithDefault(msg, 67, 0),
userRank: jspb.Message.getFieldWithDefault(msg, 68, 0),
supportedCountriesList: (f = jspb.Message.getRepeatedField(msg, 69)) == null ? undefined : f,
isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 70, false),
registrationEndTime: (f = msg.getRegistrationEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
approvalStatus: jspb.Message.getFieldWithDefault(msg, 72, 0),
isMarked: jspb.Message.getBooleanFieldWithDefault(msg, 73, false),
isAutoChargeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 74, false),
numBids: jspb.Message.getFieldWithDefault(msg, 75, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.auctions.api.v1.UserAuction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UserAuction;
  return proto.buying.auctions.api.v1.UserAuction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UserAuction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.auctions.api.v1.UserAuction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreStartTime(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addRoundStartTimes(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemFacts(value);
      break;
    case 5:
      var value = new proto.buying.auctions.api.v1.EntryTickets;
      reader.readMessage(value,proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader);
      msg.addEntryTickets(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinimumBidAmountCents(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionVideoUrl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioUrl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionBackgroundImageUrl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioTrackUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemImageUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemVideoUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem3dAssetUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserBidSoundUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidSubmittedSoundUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductTemplateName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSizeUs(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemStory(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumParticipants(value);
      break;
    case 21:
      var value = new proto.buying.auctions.api.v1.MediaAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader);
      msg.setAuctionAsset(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setTicketEntryUnlocked(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setTicketsUnlocked(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setLockedOut(value);
      break;
    case 25:
      var value = /** @type {!proto.buying.auctions.api.v1.AuctionState} */ (reader.readEnum());
      msg.setAuctionState(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedValue(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaitingRoomAudioUrl(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemAudioUrl(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserJoinedSoundUrl(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinnerShareImageUrl(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopFiveShareImageUrl(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonWinnerShareImageUrl(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStoryLengthSeconds(value);
      break;
    case 35:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStoryStartTime(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setUserJoined(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareText(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareLink(value);
      break;
    case 39:
      var value = new proto.buying.auctions.api.v1.TransparentAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader);
      msg.setTransparentAsset(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaximumParticipants(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreRegistrationTime(value);
      break;
    case 42:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaxBidCapCents(values[i]);
      }
      break;
    case 43:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsWatcher(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLotNumber(value);
      break;
    case 45:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLobbyStartTime(value);
      break;
    case 46:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUltimateEndTime(value);
      break;
    case 47:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addLobbyRoundTransitionTimes(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCondition(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSellerName(value);
      break;
    case 50:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsAbsenteeAuction(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 52:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsPublished(value);
      break;
    case 53:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    case 54:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinEstimatedValueCents(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxEstimatedValueCents(value);
      break;
    case 56:
      var value = new proto.buying.auctions.api.v1.AdpAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader);
      msg.addAdpAssets(value);
      break;
    case 57:
      var value = new proto.buying.auctions.api.v1.Money;
      reader.readMessage(value,proto.buying.auctions.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedMinEstimatedValue(value);
      break;
    case 58:
      var value = new proto.buying.auctions.api.v1.Money;
      reader.readMessage(value,proto.buying.auctions.api.v1.Money.deserializeBinaryFromReader);
      msg.setLocalizedMaxEstimatedValue(value);
      break;
    case 59:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaximumRoundWinners(values[i]);
      }
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeExpiringSoundUrl(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.addAbsenteeAuctionProductIds(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnteredUserCount(value);
      break;
    case 63:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPaymentRegistrationEnabled(value);
      break;
    case 64:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegmentId(value);
      break;
    case 65:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsBlackFridayAuction(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentHighestBidCents(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserBidAmountCents(value);
      break;
    case 68:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserRank(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedCountries(value);
      break;
    case 70:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 71:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegistrationEndTime(value);
      break;
    case 72:
      var value = /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (reader.readEnum());
      msg.setApprovalStatus(value);
      break;
    case 73:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMarked(value);
      break;
    case 74:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutoChargeEnabled(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumBids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UserAuction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UserAuction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserAuction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreStartTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRoundStartTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemFacts();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEntryTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter
    );
  }
  f = message.getMinimumBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAuctionVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAuctionAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAuctionBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAuctionAudioTrackUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getItemImageUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getItemVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getItem3dAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUserBidSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getBidSubmittedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getProductTemplateName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProductSizeUs();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getItemStory();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getNumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getAuctionAsset();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter
    );
  }
  f = message.getTicketEntryUnlocked();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getTicketsUnlocked();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLockedOut();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAuctionState();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getEstimatedValue();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getWaitingRoomAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getItemAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getUserJoinedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getTopFiveShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getNonWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getStoryLengthSeconds();
  if (f !== 0) {
    writer.writeInt32(
      34,
      f
    );
  }
  f = message.getStoryStartTime();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUserJoined();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getShareText();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getShareLink();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getTransparentAsset();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter
    );
  }
  f = message.getMaximumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      40,
      f
    );
  }
  f = message.getPreRegistrationTime();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMaxBidCapCentsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      42,
      f
    );
  }
  f = message.getIsWatcher();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotNumber();
  if (f !== 0) {
    writer.writeInt64(
      44,
      f
    );
  }
  f = message.getLobbyStartTime();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUltimateEndTime();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLobbyRoundTransitionTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      47,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductCondition();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getProductSellerName();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getIsAbsenteeAuction();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getIsPublished();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMinEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      54,
      f
    );
  }
  f = message.getMaxEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      55,
      f
    );
  }
  f = message.getAdpAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      56,
      f,
      proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter
    );
  }
  f = message.getLocalizedMinEstimatedValue();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      proto.buying.auctions.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getLocalizedMaxEstimatedValue();
  if (f != null) {
    writer.writeMessage(
      58,
      f,
      proto.buying.auctions.api.v1.Money.serializeBinaryToWriter
    );
  }
  f = message.getMaximumRoundWinnersList();
  if (f.length > 0) {
    writer.writePackedInt64(
      59,
      f
    );
  }
  f = message.getTimeExpiringSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getAbsenteeAuctionProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      61,
      f
    );
  }
  f = message.getEnteredUserCount();
  if (f !== 0) {
    writer.writeInt64(
      62,
      f
    );
  }
  f = message.getPaymentRegistrationEnabled();
  if (f != null) {
    writer.writeMessage(
      63,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSegmentId();
  if (f.length > 0) {
    writer.writeString(
      64,
      f
    );
  }
  f = message.getIsBlackFridayAuction();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCurrentHighestBidCents();
  if (f !== 0) {
    writer.writeInt64(
      66,
      f
    );
  }
  f = message.getUserBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      67,
      f
    );
  }
  f = message.getUserRank();
  if (f !== 0) {
    writer.writeInt64(
      68,
      f
    );
  }
  f = message.getSupportedCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      69,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      70,
      f
    );
  }
  f = message.getRegistrationEndTime();
  if (f != null) {
    writer.writeMessage(
      71,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      72,
      f
    );
  }
  f = message.getIsMarked();
  if (f) {
    writer.writeBool(
      73,
      f
    );
  }
  f = message.getIsAutoChargeEnabled();
  if (f) {
    writer.writeBool(
      74,
      f
    );
  }
  f = message.getNumBids();
  if (f !== 0) {
    writer.writeInt64(
      75,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp pre_start_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getPreStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setPreStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearPreStartTime = function() {
  return this.setPreStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasPreStartTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated google.protobuf.Timestamp round_start_times = 2;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getRoundStartTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setRoundStartTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addRoundStartTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearRoundStartTimesList = function() {
  return this.setRoundStartTimesList([]);
};


/**
 * optional google.protobuf.Timestamp end_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string item_facts = 4;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItemFacts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItemFacts = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated EntryTickets entry_tickets = 5;
 * @return {!Array<!proto.buying.auctions.api.v1.EntryTickets>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getEntryTicketsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.EntryTickets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.EntryTickets, 5));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.EntryTickets>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setEntryTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.EntryTickets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addEntryTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.buying.auctions.api.v1.EntryTickets, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearEntryTicketsList = function() {
  return this.setEntryTicketsList([]);
};


/**
 * optional int64 minimum_bid_amount_cents = 6;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMinimumBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMinimumBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string auction_video_url = 7;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string auction_audio_url = 8;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string auction_background_image_url = 9;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string auction_audio_track_url = 10;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionAudioTrackUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionAudioTrackUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string item_image_url = 11;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItemImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItemImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string item_video_url = 12;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItemVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItemVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string item_3d_asset_url = 13;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItem3dAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItem3dAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string user_bid_sound_url = 14;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUserBidSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setUserBidSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string bid_submitted_sound_url = 15;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getBidSubmittedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setBidSubmittedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string product_template_name = 16;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getProductTemplateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setProductTemplateName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string product_size_us = 17;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getProductSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setProductSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string release_year = 18;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string item_story = 19;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItemStory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItemStory = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional int64 num_participants = 20;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getNumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setNumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional MediaAsset auction_asset = 21;
 * @return {?proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.MediaAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.MediaAsset, 21));
};


/**
 * @param {?proto.buying.auctions.api.v1.MediaAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearAuctionAsset = function() {
  return this.setAuctionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasAuctionAsset = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.BoolValue ticket_entry_unlocked = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getTicketEntryUnlocked = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setTicketEntryUnlocked = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearTicketEntryUnlocked = function() {
  return this.setTicketEntryUnlocked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasTicketEntryUnlocked = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue tickets_unlocked = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getTicketsUnlocked = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setTicketsUnlocked = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearTicketsUnlocked = function() {
  return this.setTicketsUnlocked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasTicketsUnlocked = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.BoolValue locked_out = 24;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLockedOut = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 24));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setLockedOut = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearLockedOut = function() {
  return this.setLockedOut(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasLockedOut = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional AuctionState auction_state = 25;
 * @return {!proto.buying.auctions.api.v1.AuctionState}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionState = function() {
  return /** @type {!proto.buying.auctions.api.v1.AuctionState} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionState} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionState = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional string estimated_value = 26;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getEstimatedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setEstimatedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string waiting_room_audio_url = 27;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getWaitingRoomAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setWaitingRoomAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string item_audio_url = 28;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getItemAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setItemAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string user_joined_sound_url = 29;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUserJoinedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setUserJoinedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string auction_id = 30;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string winner_share_image_url = 31;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string top_five_share_image_url = 32;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getTopFiveShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setTopFiveShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string non_winner_share_image_url = 33;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getNonWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setNonWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional int32 story_length_seconds = 34;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getStoryLengthSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setStoryLengthSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional google.protobuf.Timestamp story_start_time = 35;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getStoryStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 35));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setStoryStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearStoryStartTime = function() {
  return this.setStoryStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasStoryStartTime = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.BoolValue user_joined = 36;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUserJoined = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 36));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setUserJoined = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearUserJoined = function() {
  return this.setUserJoined(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasUserJoined = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string share_text = 37;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getShareText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setShareText = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string share_link = 38;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getShareLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setShareLink = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional TransparentAsset transparent_asset = 39;
 * @return {?proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getTransparentAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.TransparentAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.TransparentAsset, 39));
};


/**
 * @param {?proto.buying.auctions.api.v1.TransparentAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setTransparentAsset = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearTransparentAsset = function() {
  return this.setTransparentAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasTransparentAsset = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional int64 maximum_participants = 40;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMaximumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMaximumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional google.protobuf.Timestamp pre_registration_time = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getPreRegistrationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setPreRegistrationTime = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearPreRegistrationTime = function() {
  return this.setPreRegistrationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasPreRegistrationTime = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * repeated int64 max_bid_cap_cents = 42;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMaxBidCapCentsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 42));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMaxBidCapCentsList = function(value) {
  return jspb.Message.setField(this, 42, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addMaxBidCapCents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 42, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearMaxBidCapCentsList = function() {
  return this.setMaxBidCapCentsList([]);
};


/**
 * optional google.protobuf.BoolValue is_watcher = 43;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsWatcher = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 43));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setIsWatcher = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearIsWatcher = function() {
  return this.setIsWatcher(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasIsWatcher = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional int64 lot_number = 44;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setLotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional google.protobuf.Timestamp lobby_start_time = 45;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLobbyStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 45));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setLobbyStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearLobbyStartTime = function() {
  return this.setLobbyStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasLobbyStartTime = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional google.protobuf.Timestamp ultimate_end_time = 46;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUltimateEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 46));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setUltimateEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearUltimateEndTime = function() {
  return this.setUltimateEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasUltimateEndTime = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * repeated google.protobuf.Timestamp lobby_round_transition_times = 47;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLobbyRoundTransitionTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 47));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setLobbyRoundTransitionTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 47, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addLobbyRoundTransitionTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 47, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearLobbyRoundTransitionTimesList = function() {
  return this.setLobbyRoundTransitionTimesList([]);
};


/**
 * optional string product_condition = 48;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getProductCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string product_seller_name = 49;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getProductSellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setProductSellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional google.protobuf.BoolValue is_absentee_auction = 50;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsAbsenteeAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 50));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setIsAbsenteeAuction = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearIsAbsenteeAuction = function() {
  return this.setIsAbsenteeAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasIsAbsenteeAuction = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional string brand_name = 51;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional google.protobuf.BoolValue is_published = 52;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsPublished = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 52));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setIsPublished = function(value) {
  return jspb.Message.setWrapperField(this, 52, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearIsPublished = function() {
  return this.setIsPublished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasIsPublished = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional google.protobuf.Timestamp event_time = 53;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getEventTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 53));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 53, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional int64 min_estimated_value_cents = 54;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMinEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMinEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 54, value);
};


/**
 * optional int64 max_estimated_value_cents = 55;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMaxEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMaxEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 55, value);
};


/**
 * repeated AdpAsset adp_assets = 56;
 * @return {!Array<!proto.buying.auctions.api.v1.AdpAsset>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAdpAssetsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.AdpAsset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.AdpAsset, 56));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.AdpAsset>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setAdpAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 56, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.AdpAsset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addAdpAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 56, opt_value, proto.buying.auctions.api.v1.AdpAsset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearAdpAssetsList = function() {
  return this.setAdpAssetsList([]);
};


/**
 * optional Money localized_min_estimated_value = 57;
 * @return {?proto.buying.auctions.api.v1.Money}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLocalizedMinEstimatedValue = function() {
  return /** @type{?proto.buying.auctions.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.Money, 57));
};


/**
 * @param {?proto.buying.auctions.api.v1.Money|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setLocalizedMinEstimatedValue = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearLocalizedMinEstimatedValue = function() {
  return this.setLocalizedMinEstimatedValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasLocalizedMinEstimatedValue = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional Money localized_max_estimated_value = 58;
 * @return {?proto.buying.auctions.api.v1.Money}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getLocalizedMaxEstimatedValue = function() {
  return /** @type{?proto.buying.auctions.api.v1.Money} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.Money, 58));
};


/**
 * @param {?proto.buying.auctions.api.v1.Money|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setLocalizedMaxEstimatedValue = function(value) {
  return jspb.Message.setWrapperField(this, 58, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearLocalizedMaxEstimatedValue = function() {
  return this.setLocalizedMaxEstimatedValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasLocalizedMaxEstimatedValue = function() {
  return jspb.Message.getField(this, 58) != null;
};


/**
 * repeated int64 maximum_round_winners = 59;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getMaximumRoundWinnersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 59));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setMaximumRoundWinnersList = function(value) {
  return jspb.Message.setField(this, 59, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addMaximumRoundWinners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 59, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearMaximumRoundWinnersList = function() {
  return this.setMaximumRoundWinnersList([]);
};


/**
 * optional string time_expiring_sound_url = 60;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getTimeExpiringSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setTimeExpiringSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * repeated string absentee_auction_product_ids = 61;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getAbsenteeAuctionProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 61));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setAbsenteeAuctionProductIdsList = function(value) {
  return jspb.Message.setField(this, 61, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addAbsenteeAuctionProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 61, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearAbsenteeAuctionProductIdsList = function() {
  return this.setAbsenteeAuctionProductIdsList([]);
};


/**
 * optional int64 entered_user_count = 62;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getEnteredUserCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setEnteredUserCount = function(value) {
  return jspb.Message.setProto3IntField(this, 62, value);
};


/**
 * optional google.protobuf.BoolValue payment_registration_enabled = 63;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getPaymentRegistrationEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 63));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setPaymentRegistrationEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 63, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearPaymentRegistrationEnabled = function() {
  return this.setPaymentRegistrationEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasPaymentRegistrationEnabled = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional string segment_id = 64;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 64, value);
};


/**
 * optional google.protobuf.BoolValue is_black_friday_auction = 65;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsBlackFridayAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 65));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setIsBlackFridayAuction = function(value) {
  return jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearIsBlackFridayAuction = function() {
  return this.setIsBlackFridayAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasIsBlackFridayAuction = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional int64 current_highest_bid_cents = 66;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getCurrentHighestBidCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setCurrentHighestBidCents = function(value) {
  return jspb.Message.setProto3IntField(this, 66, value);
};


/**
 * optional int64 user_bid_amount_cents = 67;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUserBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 67, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setUserBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 67, value);
};


/**
 * optional int64 user_rank = 68;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getUserRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 68, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setUserRank = function(value) {
  return jspb.Message.setProto3IntField(this, 68, value);
};


/**
 * repeated string supported_countries = 69;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getSupportedCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 69));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setSupportedCountriesList = function(value) {
  return jspb.Message.setField(this, 69, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.addSupportedCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 69, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearSupportedCountriesList = function() {
  return this.setSupportedCountriesList([]);
};


/**
 * optional bool is_private = 70;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 70, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 70, value);
};


/**
 * optional google.protobuf.Timestamp registration_end_time = 71;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getRegistrationEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 71));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
*/
proto.buying.auctions.api.v1.UserAuction.prototype.setRegistrationEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 71, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.clearRegistrationEndTime = function() {
  return this.setRegistrationEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.hasRegistrationEndTime = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional ApprovalStatus approval_status = 72;
 * @return {!proto.buying.auctions.api.v1.ApprovalStatus}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getApprovalStatus = function() {
  return /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 72, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.ApprovalStatus} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setApprovalStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 72, value);
};


/**
 * optional bool is_marked = 73;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsMarked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 73, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setIsMarked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 73, value);
};


/**
 * optional bool is_auto_charge_enabled = 74;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getIsAutoChargeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 74, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setIsAutoChargeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 74, value);
};


/**
 * optional int64 num_bids = 75;
 * @return {number}
 */
proto.buying.auctions.api.v1.UserAuction.prototype.getNumBids = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 75, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UserAuction} returns this
 */
proto.buying.auctions.api.v1.UserAuction.prototype.setNumBids = function(value) {
  return jspb.Message.setProto3IntField(this, 75, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionRequest}
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserAuctionRequest;
  return proto.buying.auctions.api.v1.GetUserAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionRequest}
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.buying.auctions.api.v1.UserAuction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionResponse}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserAuctionResponse;
  return proto.buying.auctions.api.v1.GetUserAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionResponse}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.UserAuction;
      reader.readMessage(value,proto.buying.auctions.api.v1.UserAuction.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.auctions.api.v1.UserAuction.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserAuction data = 1;
 * @return {?proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.getData = function() {
  return /** @type{?proto.buying.auctions.api.v1.UserAuction} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.UserAuction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.UserAuction|undefined} value
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionResponse} returns this
*/
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionResponse} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.GetUserAuctionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserAuctionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsRequest}
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserAuctionsRequest;
  return proto.buying.auctions.api.v1.GetUserAuctionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsRequest}
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAuctionIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserAuctionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string auction_ids = 1;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.getAuctionIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.setAuctionIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.addAuctionIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsRequest} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionsRequest.prototype.clearAuctionIdsList = function() {
  return this.setAuctionIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserAuctionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionsList: jspb.Message.toObjectList(msg.getAuctionsList(),
    proto.buying.auctions.api.v1.UserAuction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsResponse}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserAuctionsResponse;
  return proto.buying.auctions.api.v1.GetUserAuctionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsResponse}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.UserAuction;
      reader.readMessage(value,proto.buying.auctions.api.v1.UserAuction.deserializeBinaryFromReader);
      msg.addAuctions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserAuctionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserAuctionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.auctions.api.v1.UserAuction.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserAuction auctions = 1;
 * @return {!Array<!proto.buying.auctions.api.v1.UserAuction>}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.getAuctionsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.UserAuction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.UserAuction, 1));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.UserAuction>} value
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsResponse} returns this
*/
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.setAuctionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.UserAuction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.addAuctions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.auctions.api.v1.UserAuction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.GetUserAuctionsResponse} returns this
 */
proto.buying.auctions.api.v1.GetUserAuctionsResponse.prototype.clearAuctionsList = function() {
  return this.setAuctionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.EnterAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.EnterAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
billingInfoId: jspb.Message.getFieldWithDefault(msg, 2, ""),
shippingAddressId: jspb.Message.getFieldWithDefault(msg, 3, ""),
paymentNonce: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.EnterAuctionRequest;
  return proto.buying.auctions.api.v1.EnterAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.EnterAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingInfoId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingAddressId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentNonce(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.EnterAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.EnterAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBillingInfoId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShippingAddressId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaymentNonce();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string billing_info_id = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.getBillingInfoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.setBillingInfoId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string shipping_address_id = 3;
 * @return {string}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.getShippingAddressId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.setShippingAddressId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string payment_nonce = 4;
 * @return {string}
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.getPaymentNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.EnterAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.EnterAuctionRequest.prototype.setPaymentNonce = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.EnterAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.EnterAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.EnterAuctionResponse}
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.EnterAuctionResponse;
  return proto.buying.auctions.api.v1.EnterAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.EnterAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.EnterAuctionResponse}
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.EnterAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.EnterAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.EnterAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest;
  return proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest} returns this
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.buying.auctions.api.v1.UserAuction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse;
  return proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.UserAuction;
      reader.readMessage(value,proto.buying.auctions.api.v1.UserAuction.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.auctions.api.v1.UserAuction.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserAuction data = 1;
 * @return {?proto.buying.auctions.api.v1.UserAuction}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.getData = function() {
  return /** @type{?proto.buying.auctions.api.v1.UserAuction} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.UserAuction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.UserAuction|undefined} value
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse} returns this
*/
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse} returns this
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UnlockAuctionTicketsResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UpdateBidRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UpdateBidRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateBidRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
bidAmountCents: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UpdateBidRequest}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UpdateBidRequest;
  return proto.buying.auctions.api.v1.UpdateBidRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UpdateBidRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UpdateBidRequest}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBidAmountCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UpdateBidRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UpdateBidRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateBidRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateBidRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 bid_amount_cents = 2;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.getBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateBidRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateBidRequest.prototype.setBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UpdateBidResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UpdateBidResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UpdateBidResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateBidResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UpdateBidResponse}
 */
proto.buying.auctions.api.v1.UpdateBidResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UpdateBidResponse;
  return proto.buying.auctions.api.v1.UpdateBidResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UpdateBidResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UpdateBidResponse}
 */
proto.buying.auctions.api.v1.UpdateBidResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UpdateBidResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UpdateBidResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UpdateBidResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateBidResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UserEnteredAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UserEnteredAuctionRequest;
  return proto.buying.auctions.api.v1.UserEnteredAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UserEnteredAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UserEnteredAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UserEnteredAuctionRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UserEnteredAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UserEnteredAuctionResponse}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UserEnteredAuctionResponse;
  return proto.buying.auctions.api.v1.UserEnteredAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UserEnteredAuctionResponse}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UserEnteredAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UserEnteredAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UserEnteredAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserPrizesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionEventType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesRequest}
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserPrizesRequest;
  return proto.buying.auctions.api.v1.GetUserPrizesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesRequest}
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.buying.auctions.api.v1.AuctionEventType} */ (reader.readEnum());
      msg.setAuctionEventType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserPrizesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional AuctionEventType auction_event_type = 1;
 * @return {!proto.buying.auctions.api.v1.AuctionEventType}
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.prototype.getAuctionEventType = function() {
  return /** @type {!proto.buying.auctions.api.v1.AuctionEventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionEventType} value
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesRequest} returns this
 */
proto.buying.auctions.api.v1.GetUserPrizesRequest.prototype.setAuctionEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetUserPrizesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
prizesList: jspb.Message.toObjectList(msg.getPrizesList(),
    proto.buying.auctions.api.v1.Prize.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesResponse}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetUserPrizesResponse;
  return proto.buying.auctions.api.v1.GetUserPrizesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesResponse}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.Prize;
      reader.readMessage(value,proto.buying.auctions.api.v1.Prize.deserializeBinaryFromReader);
      msg.addPrizes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetUserPrizesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetUserPrizesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.auctions.api.v1.Prize.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Prize prizes = 1;
 * @return {!Array<!proto.buying.auctions.api.v1.Prize>}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.getPrizesList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.Prize>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.Prize, 1));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.Prize>} value
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesResponse} returns this
*/
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.setPrizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.Prize=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Prize}
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.addPrizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.auctions.api.v1.Prize, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.GetUserPrizesResponse} returns this
 */
proto.buying.auctions.api.v1.GetUserPrizesResponse.prototype.clearPrizesList = function() {
  return this.setPrizesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.Auction.repeatedFields_ = [3,6,9,40,44,53,55,61,67];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.Auction.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.Auction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.Auction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Auction.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
preStartTime: (f = msg.getPreStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
roundStartTimesList: jspb.Message.toObjectList(msg.getRoundStartTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
itemFacts: jspb.Message.getFieldWithDefault(msg, 5, ""),
entryTicketsList: jspb.Message.toObjectList(msg.getEntryTicketsList(),
    proto.buying.auctions.api.v1.EntryTickets.toObject, includeInstance),
productId: jspb.Message.getFieldWithDefault(msg, 7, ""),
maximumParticipants: jspb.Message.getFieldWithDefault(msg, 8, 0),
maximumRoundWinnersList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
minimumBidAmountCents: jspb.Message.getFieldWithDefault(msg, 10, 0),
auctionVideoUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
auctionAudioUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
auctionBackgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
auctionAudioTrackUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
itemImageUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
itemVideoUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
item3dAssetUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
userBidSoundUrl: jspb.Message.getFieldWithDefault(msg, 18, ""),
productTemplateName: jspb.Message.getFieldWithDefault(msg, 19, ""),
productSizeUs: jspb.Message.getFieldWithDefault(msg, 20, ""),
releaseYear: jspb.Message.getFieldWithDefault(msg, 21, ""),
itemStory: jspb.Message.getFieldWithDefault(msg, 22, ""),
numParticipants: jspb.Message.getFieldWithDefault(msg, 23, 0),
auctionAsset: (f = msg.getAuctionAsset()) && proto.buying.auctions.api.v1.MediaAsset.toObject(includeInstance, f),
bidSubmittedSoundUrl: jspb.Message.getFieldWithDefault(msg, 25, ""),
estimatedValue: jspb.Message.getFieldWithDefault(msg, 26, ""),
waitingRoomAudioUrl: jspb.Message.getFieldWithDefault(msg, 27, ""),
itemAudioUrl: jspb.Message.getFieldWithDefault(msg, 28, ""),
userJoinedSoundUrl: jspb.Message.getFieldWithDefault(msg, 29, ""),
winnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 30, ""),
topFiveShareImageUrl: jspb.Message.getFieldWithDefault(msg, 31, ""),
nonWinnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 32, ""),
storyLengthSeconds: jspb.Message.getFieldWithDefault(msg, 33, 0),
storyStartTime: (f = msg.getStoryStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
shareText: jspb.Message.getFieldWithDefault(msg, 35, ""),
shareLink: jspb.Message.getFieldWithDefault(msg, 36, ""),
transparentAsset: (f = msg.getTransparentAsset()) && proto.buying.auctions.api.v1.TransparentAsset.toObject(includeInstance, f),
reservedAmountCents: jspb.Message.getFieldWithDefault(msg, 38, 0),
preRegistrationTime: (f = msg.getPreRegistrationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
maxBidCapCentsList: (f = jspb.Message.getRepeatedField(msg, 40)) == null ? undefined : f,
lotNumber: jspb.Message.getFieldWithDefault(msg, 41, 0),
lobbyStartTime: (f = msg.getLobbyStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
ultimateEndTime: (f = msg.getUltimateEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lobbyRoundTransitionTimesList: jspb.Message.toObjectList(msg.getLobbyRoundTransitionTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
productCondition: jspb.Message.getFieldWithDefault(msg, 45, ""),
productSellerName: jspb.Message.getFieldWithDefault(msg, 46, ""),
isAbsenteeAuction: (f = msg.getIsAbsenteeAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
brandName: jspb.Message.getFieldWithDefault(msg, 48, ""),
isPublished: (f = msg.getIsPublished()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
eventTime: (f = msg.getEventTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
minEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 51, 0),
maxEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 52, 0),
adpAssetsList: jspb.Message.toObjectList(msg.getAdpAssetsList(),
    proto.buying.auctions.api.v1.AdpAsset.toObject, includeInstance),
timeExpiringSoundUrl: jspb.Message.getFieldWithDefault(msg, 54, ""),
absenteeAuctionProductIdsList: (f = jspb.Message.getRepeatedField(msg, 55)) == null ? undefined : f,
paymentRegistrationEnabled: (f = msg.getPaymentRegistrationEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
isBlackFridayAuction: (f = msg.getIsBlackFridayAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
segmentId: jspb.Message.getFieldWithDefault(msg, 58, ""),
thresholdAlertPriceCents: jspb.Message.getFieldWithDefault(msg, 59, 0),
locked: (f = msg.getLocked()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
supportedCountriesList: (f = jspb.Message.getRepeatedField(msg, 61)) == null ? undefined : f,
isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 62, false),
registrationEndTime: (f = msg.getRegistrationEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
claimPrizeWindowMinutes: jspb.Message.getFieldWithDefault(msg, 64, 0),
thresholdAutomaticBidRemovalPriceCents: jspb.Message.getFieldWithDefault(msg, 65, 0),
isAutoChargeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 66, false),
selectedWinnersList: (f = jspb.Message.getRepeatedField(msg, 67)) == null ? undefined : f,
auctionCompletionType: jspb.Message.getFieldWithDefault(msg, 68, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.Auction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.Auction;
  return proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.Auction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreStartTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addRoundStartTimes(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemFacts(value);
      break;
    case 6:
      var value = new proto.buying.auctions.api.v1.EntryTickets;
      reader.readMessage(value,proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader);
      msg.addEntryTickets(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaximumParticipants(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaximumRoundWinners(values[i]);
      }
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinimumBidAmountCents(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionVideoUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionBackgroundImageUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioTrackUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemImageUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemVideoUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem3dAssetUrl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserBidSoundUrl(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductTemplateName(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSizeUs(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemStory(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumParticipants(value);
      break;
    case 24:
      var value = new proto.buying.auctions.api.v1.MediaAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader);
      msg.setAuctionAsset(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidSubmittedSoundUrl(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedValue(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaitingRoomAudioUrl(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemAudioUrl(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserJoinedSoundUrl(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinnerShareImageUrl(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopFiveShareImageUrl(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonWinnerShareImageUrl(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStoryLengthSeconds(value);
      break;
    case 34:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStoryStartTime(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareText(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareLink(value);
      break;
    case 37:
      var value = new proto.buying.auctions.api.v1.TransparentAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader);
      msg.setTransparentAsset(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReservedAmountCents(value);
      break;
    case 39:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreRegistrationTime(value);
      break;
    case 40:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaxBidCapCents(values[i]);
      }
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLotNumber(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLobbyStartTime(value);
      break;
    case 43:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUltimateEndTime(value);
      break;
    case 44:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addLobbyRoundTransitionTimes(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCondition(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSellerName(value);
      break;
    case 47:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsAbsenteeAuction(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 49:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsPublished(value);
      break;
    case 50:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinEstimatedValueCents(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxEstimatedValueCents(value);
      break;
    case 53:
      var value = new proto.buying.auctions.api.v1.AdpAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader);
      msg.addAdpAssets(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeExpiringSoundUrl(value);
      break;
    case 55:
      var value = /** @type {string} */ (reader.readString());
      msg.addAbsenteeAuctionProductIds(value);
      break;
    case 56:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPaymentRegistrationEnabled(value);
      break;
    case 57:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsBlackFridayAuction(value);
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegmentId(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThresholdAlertPriceCents(value);
      break;
    case 60:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setLocked(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedCountries(value);
      break;
    case 62:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 63:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegistrationEndTime(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimPrizeWindowMinutes(value);
      break;
    case 65:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThresholdAutomaticBidRemovalPriceCents(value);
      break;
    case 66:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutoChargeEnabled(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedWinners(value);
      break;
    case 68:
      var value = /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (reader.readEnum());
      msg.setAuctionCompletionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.Auction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.Auction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRoundStartTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemFacts();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEntryTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMaximumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getMaximumRoundWinnersList();
  if (f.length > 0) {
    writer.writePackedInt64(
      9,
      f
    );
  }
  f = message.getMinimumBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAuctionVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAuctionAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAuctionBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAuctionAudioTrackUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getItemImageUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getItemVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getItem3dAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUserBidSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getProductTemplateName();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getProductSizeUs();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getItemStory();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getNumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getAuctionAsset();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter
    );
  }
  f = message.getBidSubmittedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getEstimatedValue();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getWaitingRoomAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getItemAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getUserJoinedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getTopFiveShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getNonWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getStoryLengthSeconds();
  if (f !== 0) {
    writer.writeInt32(
      33,
      f
    );
  }
  f = message.getStoryStartTime();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getShareText();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getShareLink();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getTransparentAsset();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter
    );
  }
  f = message.getReservedAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      38,
      f
    );
  }
  f = message.getPreRegistrationTime();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMaxBidCapCentsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      40,
      f
    );
  }
  f = message.getLotNumber();
  if (f !== 0) {
    writer.writeInt64(
      41,
      f
    );
  }
  f = message.getLobbyStartTime();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUltimateEndTime();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLobbyRoundTransitionTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      44,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductCondition();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getProductSellerName();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getIsAbsenteeAuction();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getIsPublished();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMinEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      51,
      f
    );
  }
  f = message.getMaxEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      52,
      f
    );
  }
  f = message.getAdpAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      53,
      f,
      proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter
    );
  }
  f = message.getTimeExpiringSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getAbsenteeAuctionProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      55,
      f
    );
  }
  f = message.getPaymentRegistrationEnabled();
  if (f != null) {
    writer.writeMessage(
      56,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsBlackFridayAuction();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSegmentId();
  if (f.length > 0) {
    writer.writeString(
      58,
      f
    );
  }
  f = message.getThresholdAlertPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      59,
      f
    );
  }
  f = message.getLocked();
  if (f != null) {
    writer.writeMessage(
      60,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSupportedCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      61,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      62,
      f
    );
  }
  f = message.getRegistrationEndTime();
  if (f != null) {
    writer.writeMessage(
      63,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClaimPrizeWindowMinutes();
  if (f !== 0) {
    writer.writeInt32(
      64,
      f
    );
  }
  f = message.getThresholdAutomaticBidRemovalPriceCents();
  if (f !== 0) {
    writer.writeInt32(
      65,
      f
    );
  }
  f = message.getIsAutoChargeEnabled();
  if (f) {
    writer.writeBool(
      66,
      f
    );
  }
  f = message.getSelectedWinnersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      67,
      f
    );
  }
  f = message.getAuctionCompletionType();
  if (f !== 0.0) {
    writer.writeEnum(
      68,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp pre_start_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getPreStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setPreStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearPreStartTime = function() {
  return this.setPreStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasPreStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated google.protobuf.Timestamp round_start_times = 3;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getRoundStartTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setRoundStartTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.addRoundStartTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearRoundStartTimesList = function() {
  return this.setRoundStartTimesList([]);
};


/**
 * optional google.protobuf.Timestamp end_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string item_facts = 5;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItemFacts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItemFacts = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated EntryTickets entry_tickets = 6;
 * @return {!Array<!proto.buying.auctions.api.v1.EntryTickets>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getEntryTicketsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.EntryTickets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.EntryTickets, 6));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.EntryTickets>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setEntryTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.EntryTickets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.Auction.prototype.addEntryTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.buying.auctions.api.v1.EntryTickets, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearEntryTicketsList = function() {
  return this.setEntryTicketsList([]);
};


/**
 * optional string product_id = 7;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 maximum_participants = 8;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMaximumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMaximumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated int64 maximum_round_winners = 9;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMaximumRoundWinnersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMaximumRoundWinnersList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.addMaximumRoundWinners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearMaximumRoundWinnersList = function() {
  return this.setMaximumRoundWinnersList([]);
};


/**
 * optional int64 minimum_bid_amount_cents = 10;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMinimumBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMinimumBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string auction_video_url = 11;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAuctionVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string auction_audio_url = 12;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAuctionAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string auction_background_image_url = 13;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAuctionBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string auction_audio_track_url = 14;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionAudioTrackUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAuctionAudioTrackUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string item_image_url = 15;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItemImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItemImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string item_video_url = 16;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItemVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItemVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string item_3d_asset_url = 17;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItem3dAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItem3dAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string user_bid_sound_url = 18;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getUserBidSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setUserBidSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string product_template_name = 19;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getProductTemplateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setProductTemplateName = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string product_size_us = 20;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getProductSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setProductSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string release_year = 21;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string item_story = 22;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItemStory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItemStory = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int64 num_participants = 23;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getNumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setNumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional MediaAsset auction_asset = 24;
 * @return {?proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.MediaAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.MediaAsset, 24));
};


/**
 * @param {?proto.buying.auctions.api.v1.MediaAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setAuctionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearAuctionAsset = function() {
  return this.setAuctionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasAuctionAsset = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string bid_submitted_sound_url = 25;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getBidSubmittedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setBidSubmittedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string estimated_value = 26;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getEstimatedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setEstimatedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string waiting_room_audio_url = 27;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getWaitingRoomAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setWaitingRoomAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string item_audio_url = 28;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getItemAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setItemAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string user_joined_sound_url = 29;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getUserJoinedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setUserJoinedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string winner_share_image_url = 30;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string top_five_share_image_url = 31;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getTopFiveShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setTopFiveShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string non_winner_share_image_url = 32;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getNonWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setNonWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional int32 story_length_seconds = 33;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getStoryLengthSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setStoryLengthSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional google.protobuf.Timestamp story_start_time = 34;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getStoryStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 34));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setStoryStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearStoryStartTime = function() {
  return this.setStoryStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasStoryStartTime = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional string share_text = 35;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getShareText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setShareText = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string share_link = 36;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getShareLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setShareLink = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional TransparentAsset transparent_asset = 37;
 * @return {?proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.Auction.prototype.getTransparentAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.TransparentAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.TransparentAsset, 37));
};


/**
 * @param {?proto.buying.auctions.api.v1.TransparentAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setTransparentAsset = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearTransparentAsset = function() {
  return this.setTransparentAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasTransparentAsset = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional int64 reserved_amount_cents = 38;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getReservedAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setReservedAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional google.protobuf.Timestamp pre_registration_time = 39;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getPreRegistrationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 39));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setPreRegistrationTime = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearPreRegistrationTime = function() {
  return this.setPreRegistrationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasPreRegistrationTime = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * repeated int64 max_bid_cap_cents = 40;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMaxBidCapCentsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 40));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMaxBidCapCentsList = function(value) {
  return jspb.Message.setField(this, 40, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.addMaxBidCapCents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 40, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearMaxBidCapCentsList = function() {
  return this.setMaxBidCapCentsList([]);
};


/**
 * optional int64 lot_number = 41;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getLotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setLotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional google.protobuf.Timestamp lobby_start_time = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getLobbyStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setLobbyStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearLobbyStartTime = function() {
  return this.setLobbyStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasLobbyStartTime = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional google.protobuf.Timestamp ultimate_end_time = 43;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getUltimateEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 43));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setUltimateEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearUltimateEndTime = function() {
  return this.setUltimateEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasUltimateEndTime = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * repeated google.protobuf.Timestamp lobby_round_transition_times = 44;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getLobbyRoundTransitionTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 44));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setLobbyRoundTransitionTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 44, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.addLobbyRoundTransitionTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 44, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearLobbyRoundTransitionTimesList = function() {
  return this.setLobbyRoundTransitionTimesList([]);
};


/**
 * optional string product_condition = 45;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getProductCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string product_seller_name = 46;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getProductSellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setProductSellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional google.protobuf.BoolValue is_absentee_auction = 47;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.Auction.prototype.getIsAbsenteeAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 47));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setIsAbsenteeAuction = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearIsAbsenteeAuction = function() {
  return this.setIsAbsenteeAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasIsAbsenteeAuction = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional string brand_name = 48;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional google.protobuf.BoolValue is_published = 49;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.Auction.prototype.getIsPublished = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 49));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setIsPublished = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearIsPublished = function() {
  return this.setIsPublished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasIsPublished = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional google.protobuf.Timestamp event_time = 50;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getEventTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 50));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional int64 min_estimated_value_cents = 51;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMinEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMinEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * optional int64 max_estimated_value_cents = 52;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getMaxEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setMaxEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 52, value);
};


/**
 * repeated AdpAsset adp_assets = 53;
 * @return {!Array<!proto.buying.auctions.api.v1.AdpAsset>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAdpAssetsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.AdpAsset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.AdpAsset, 53));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.AdpAsset>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setAdpAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 53, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.AdpAsset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.Auction.prototype.addAdpAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 53, opt_value, proto.buying.auctions.api.v1.AdpAsset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearAdpAssetsList = function() {
  return this.setAdpAssetsList([]);
};


/**
 * optional string time_expiring_sound_url = 54;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getTimeExpiringSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setTimeExpiringSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * repeated string absentee_auction_product_ids = 55;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAbsenteeAuctionProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 55));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAbsenteeAuctionProductIdsList = function(value) {
  return jspb.Message.setField(this, 55, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.addAbsenteeAuctionProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 55, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearAbsenteeAuctionProductIdsList = function() {
  return this.setAbsenteeAuctionProductIdsList([]);
};


/**
 * optional google.protobuf.BoolValue payment_registration_enabled = 56;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.Auction.prototype.getPaymentRegistrationEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 56));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setPaymentRegistrationEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 56, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearPaymentRegistrationEnabled = function() {
  return this.setPaymentRegistrationEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasPaymentRegistrationEnabled = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional google.protobuf.BoolValue is_black_friday_auction = 57;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.Auction.prototype.getIsBlackFridayAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 57));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setIsBlackFridayAuction = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearIsBlackFridayAuction = function() {
  return this.setIsBlackFridayAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasIsBlackFridayAuction = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional string segment_id = 58;
 * @return {string}
 */
proto.buying.auctions.api.v1.Auction.prototype.getSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 58, value);
};


/**
 * optional int64 threshold_alert_price_cents = 59;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getThresholdAlertPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setThresholdAlertPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 59, value);
};


/**
 * optional google.protobuf.BoolValue locked = 60;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.Auction.prototype.getLocked = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 60));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setLocked = function(value) {
  return jspb.Message.setWrapperField(this, 60, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearLocked = function() {
  return this.setLocked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasLocked = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * repeated string supported_countries = 61;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getSupportedCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 61));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setSupportedCountriesList = function(value) {
  return jspb.Message.setField(this, 61, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.addSupportedCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 61, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearSupportedCountriesList = function() {
  return this.setSupportedCountriesList([]);
};


/**
 * optional bool is_private = 62;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 62, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 62, value);
};


/**
 * optional google.protobuf.Timestamp registration_end_time = 63;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.Auction.prototype.getRegistrationEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 63));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
*/
proto.buying.auctions.api.v1.Auction.prototype.setRegistrationEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 63, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearRegistrationEndTime = function() {
  return this.setRegistrationEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.hasRegistrationEndTime = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional int32 claim_prize_window_minutes = 64;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getClaimPrizeWindowMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setClaimPrizeWindowMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 64, value);
};


/**
 * optional int32 threshold_automatic_bid_removal_price_cents = 65;
 * @return {number}
 */
proto.buying.auctions.api.v1.Auction.prototype.getThresholdAutomaticBidRemovalPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setThresholdAutomaticBidRemovalPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 65, value);
};


/**
 * optional bool is_auto_charge_enabled = 66;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.Auction.prototype.getIsAutoChargeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 66, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setIsAutoChargeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 66, value);
};


/**
 * repeated string selected_winners = 67;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.Auction.prototype.getSelectedWinnersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 67));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setSelectedWinnersList = function(value) {
  return jspb.Message.setField(this, 67, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.addSelectedWinners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 67, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.clearSelectedWinnersList = function() {
  return this.setSelectedWinnersList([]);
};


/**
 * optional AuctionCompletionType auction_completion_type = 68;
 * @return {!proto.buying.auctions.api.v1.AuctionCompletionType}
 */
proto.buying.auctions.api.v1.Auction.prototype.getAuctionCompletionType = function() {
  return /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (jspb.Message.getFieldWithDefault(this, 68, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionCompletionType} value
 * @return {!proto.buying.auctions.api.v1.Auction} returns this
 */
proto.buying.auctions.api.v1.Auction.prototype.setAuctionCompletionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 68, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.repeatedFields_ = [2,5,21,39,43,52,54,59];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.CreateAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.CreateAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
preStartTime: (f = msg.getPreStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
roundStartTimesList: jspb.Message.toObjectList(msg.getRoundStartTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
itemFacts: jspb.Message.getFieldWithDefault(msg, 4, ""),
entryTicketsList: jspb.Message.toObjectList(msg.getEntryTicketsList(),
    proto.buying.auctions.api.v1.EntryTickets.toObject, includeInstance),
productId: jspb.Message.getFieldWithDefault(msg, 6, ""),
minimumBidAmountCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
auctionVideoUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
auctionAudioUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
auctionBackgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
auctionAudioTrackUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
itemImageUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
itemVideoUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
item3dAssetUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
userBidSoundUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
bidSubmittedSoundUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
productTemplateName: jspb.Message.getFieldWithDefault(msg, 17, ""),
productSizeUs: jspb.Message.getFieldWithDefault(msg, 18, ""),
releaseYear: jspb.Message.getFieldWithDefault(msg, 19, ""),
itemStory: jspb.Message.getFieldWithDefault(msg, 20, ""),
maximumRoundWinnersList: (f = jspb.Message.getRepeatedField(msg, 21)) == null ? undefined : f,
maximumParticipants: jspb.Message.getFieldWithDefault(msg, 22, 0),
auctionAsset: (f = msg.getAuctionAsset()) && proto.buying.auctions.api.v1.MediaAsset.toObject(includeInstance, f),
estimatedValue: jspb.Message.getFieldWithDefault(msg, 24, ""),
waitingRoomAudioUrl: jspb.Message.getFieldWithDefault(msg, 25, ""),
itemAudioUrl: jspb.Message.getFieldWithDefault(msg, 26, ""),
userJoinedSoundUrl: jspb.Message.getFieldWithDefault(msg, 27, ""),
winnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 28, ""),
topFiveShareImageUrl: jspb.Message.getFieldWithDefault(msg, 29, ""),
nonWinnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 30, ""),
storyLengthSeconds: jspb.Message.getFieldWithDefault(msg, 31, 0),
storyStartTime: (f = msg.getStoryStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
shareText: jspb.Message.getFieldWithDefault(msg, 33, ""),
shareLink: jspb.Message.getFieldWithDefault(msg, 34, ""),
transparentAsset: (f = msg.getTransparentAsset()) && proto.buying.auctions.api.v1.TransparentAsset.toObject(includeInstance, f),
reservedAmountCents: jspb.Message.getFieldWithDefault(msg, 36, 0),
preRegistrationTime: (f = msg.getPreRegistrationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
maxBidCapCentsList: (f = jspb.Message.getRepeatedField(msg, 39)) == null ? undefined : f,
lotNumber: jspb.Message.getFieldWithDefault(msg, 40, 0),
lobbyStartTime: (f = msg.getLobbyStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
ultimateEndTime: (f = msg.getUltimateEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lobbyRoundTransitionTimesList: jspb.Message.toObjectList(msg.getLobbyRoundTransitionTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
productCondition: jspb.Message.getFieldWithDefault(msg, 44, ""),
productSellerName: jspb.Message.getFieldWithDefault(msg, 45, ""),
isAbsenteeAuction: (f = msg.getIsAbsenteeAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
brandName: jspb.Message.getFieldWithDefault(msg, 47, ""),
isPublished: (f = msg.getIsPublished()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
eventTime: (f = msg.getEventTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
minEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 50, 0),
maxEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 51, 0),
adpAssetsList: jspb.Message.toObjectList(msg.getAdpAssetsList(),
    proto.buying.auctions.api.v1.AdpAsset.toObject, includeInstance),
timeExpiringSoundUrl: jspb.Message.getFieldWithDefault(msg, 53, ""),
absenteeAuctionProductIdsList: (f = jspb.Message.getRepeatedField(msg, 54)) == null ? undefined : f,
paymentRegistrationEnabled: (f = msg.getPaymentRegistrationEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
isBlackFridayAuction: (f = msg.getIsBlackFridayAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
segmentId: jspb.Message.getFieldWithDefault(msg, 57, ""),
thresholdAlertPriceCents: jspb.Message.getFieldWithDefault(msg, 58, 0),
supportedCountriesList: (f = jspb.Message.getRepeatedField(msg, 59)) == null ? undefined : f,
isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
registrationEndTime: (f = msg.getRegistrationEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
claimPrizeWindowMinutes: jspb.Message.getFieldWithDefault(msg, 62, 0),
thresholdAutomaticBidRemovalPriceCents: jspb.Message.getFieldWithDefault(msg, 63, 0),
isAutoChargeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 64, false),
auctionCompletionType: jspb.Message.getFieldWithDefault(msg, 65, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.CreateAuctionRequest;
  return proto.buying.auctions.api.v1.CreateAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.CreateAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreStartTime(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addRoundStartTimes(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemFacts(value);
      break;
    case 5:
      var value = new proto.buying.auctions.api.v1.EntryTickets;
      reader.readMessage(value,proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader);
      msg.addEntryTickets(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinimumBidAmountCents(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionVideoUrl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioUrl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionBackgroundImageUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioTrackUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemImageUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemVideoUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem3dAssetUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserBidSoundUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidSubmittedSoundUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductTemplateName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSizeUs(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemStory(value);
      break;
    case 21:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaximumRoundWinners(values[i]);
      }
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaximumParticipants(value);
      break;
    case 23:
      var value = new proto.buying.auctions.api.v1.MediaAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader);
      msg.setAuctionAsset(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedValue(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaitingRoomAudioUrl(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemAudioUrl(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserJoinedSoundUrl(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinnerShareImageUrl(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopFiveShareImageUrl(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonWinnerShareImageUrl(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStoryLengthSeconds(value);
      break;
    case 32:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStoryStartTime(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareText(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareLink(value);
      break;
    case 35:
      var value = new proto.buying.auctions.api.v1.TransparentAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader);
      msg.setTransparentAsset(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReservedAmountCents(value);
      break;
    case 38:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreRegistrationTime(value);
      break;
    case 39:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaxBidCapCents(values[i]);
      }
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLotNumber(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLobbyStartTime(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUltimateEndTime(value);
      break;
    case 43:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addLobbyRoundTransitionTimes(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCondition(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSellerName(value);
      break;
    case 46:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsAbsenteeAuction(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 48:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsPublished(value);
      break;
    case 49:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinEstimatedValueCents(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxEstimatedValueCents(value);
      break;
    case 52:
      var value = new proto.buying.auctions.api.v1.AdpAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader);
      msg.addAdpAssets(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeExpiringSoundUrl(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.addAbsenteeAuctionProductIds(value);
      break;
    case 55:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPaymentRegistrationEnabled(value);
      break;
    case 56:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsBlackFridayAuction(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegmentId(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThresholdAlertPriceCents(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedCountries(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 61:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegistrationEndTime(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimPrizeWindowMinutes(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThresholdAutomaticBidRemovalPriceCents(value);
      break;
    case 64:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutoChargeEnabled(value);
      break;
    case 65:
      var value = /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (reader.readEnum());
      msg.setAuctionCompletionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.CreateAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.CreateAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreStartTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRoundStartTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemFacts();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEntryTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinimumBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAuctionVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAuctionAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAuctionBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAuctionAudioTrackUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getItemImageUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getItemVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getItem3dAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUserBidSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBidSubmittedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getProductTemplateName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getProductSizeUs();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getItemStory();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMaximumRoundWinnersList();
  if (f.length > 0) {
    writer.writePackedInt64(
      21,
      f
    );
  }
  f = message.getMaximumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getAuctionAsset();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter
    );
  }
  f = message.getEstimatedValue();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getWaitingRoomAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getItemAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getUserJoinedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getTopFiveShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getNonWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getStoryLengthSeconds();
  if (f !== 0) {
    writer.writeInt32(
      31,
      f
    );
  }
  f = message.getStoryStartTime();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getShareText();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getShareLink();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getTransparentAsset();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter
    );
  }
  f = message.getReservedAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      36,
      f
    );
  }
  f = message.getPreRegistrationTime();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMaxBidCapCentsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      39,
      f
    );
  }
  f = message.getLotNumber();
  if (f !== 0) {
    writer.writeInt64(
      40,
      f
    );
  }
  f = message.getLobbyStartTime();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUltimateEndTime();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLobbyRoundTransitionTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      43,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductCondition();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getProductSellerName();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getIsAbsenteeAuction();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getIsPublished();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMinEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      50,
      f
    );
  }
  f = message.getMaxEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      51,
      f
    );
  }
  f = message.getAdpAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      52,
      f,
      proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter
    );
  }
  f = message.getTimeExpiringSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getAbsenteeAuctionProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      54,
      f
    );
  }
  f = message.getPaymentRegistrationEnabled();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsBlackFridayAuction();
  if (f != null) {
    writer.writeMessage(
      56,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSegmentId();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getThresholdAlertPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      58,
      f
    );
  }
  f = message.getSupportedCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      59,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getRegistrationEndTime();
  if (f != null) {
    writer.writeMessage(
      61,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClaimPrizeWindowMinutes();
  if (f !== 0) {
    writer.writeInt32(
      62,
      f
    );
  }
  f = message.getThresholdAutomaticBidRemovalPriceCents();
  if (f !== 0) {
    writer.writeInt32(
      63,
      f
    );
  }
  f = message.getIsAutoChargeEnabled();
  if (f) {
    writer.writeBool(
      64,
      f
    );
  }
  f = message.getAuctionCompletionType();
  if (f !== 0.0) {
    writer.writeEnum(
      65,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp pre_start_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getPreStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setPreStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearPreStartTime = function() {
  return this.setPreStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasPreStartTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated google.protobuf.Timestamp round_start_times = 2;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getRoundStartTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setRoundStartTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addRoundStartTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearRoundStartTimesList = function() {
  return this.setRoundStartTimesList([]);
};


/**
 * optional google.protobuf.Timestamp end_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string item_facts = 4;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItemFacts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItemFacts = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated EntryTickets entry_tickets = 5;
 * @return {!Array<!proto.buying.auctions.api.v1.EntryTickets>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getEntryTicketsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.EntryTickets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.EntryTickets, 5));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.EntryTickets>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setEntryTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.EntryTickets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addEntryTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.buying.auctions.api.v1.EntryTickets, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearEntryTicketsList = function() {
  return this.setEntryTicketsList([]);
};


/**
 * optional string product_id = 6;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 minimum_bid_amount_cents = 7;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMinimumBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMinimumBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string auction_video_url = 8;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string auction_audio_url = 9;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string auction_background_image_url = 10;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string auction_audio_track_url = 11;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionAudioTrackUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionAudioTrackUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string item_image_url = 12;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItemImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItemImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string item_video_url = 13;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItemVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItemVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string item_3d_asset_url = 14;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItem3dAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItem3dAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string user_bid_sound_url = 15;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getUserBidSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setUserBidSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string bid_submitted_sound_url = 16;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getBidSubmittedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setBidSubmittedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string product_template_name = 17;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getProductTemplateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setProductTemplateName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string product_size_us = 18;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getProductSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setProductSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string release_year = 19;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string item_story = 20;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItemStory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItemStory = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * repeated int64 maximum_round_winners = 21;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMaximumRoundWinnersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 21));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMaximumRoundWinnersList = function(value) {
  return jspb.Message.setField(this, 21, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addMaximumRoundWinners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 21, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearMaximumRoundWinnersList = function() {
  return this.setMaximumRoundWinnersList([]);
};


/**
 * optional int64 maximum_participants = 22;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMaximumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMaximumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional MediaAsset auction_asset = 23;
 * @return {?proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.MediaAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.MediaAsset, 23));
};


/**
 * @param {?proto.buying.auctions.api.v1.MediaAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearAuctionAsset = function() {
  return this.setAuctionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasAuctionAsset = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional string estimated_value = 24;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getEstimatedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setEstimatedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string waiting_room_audio_url = 25;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getWaitingRoomAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setWaitingRoomAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string item_audio_url = 26;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getItemAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setItemAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string user_joined_sound_url = 27;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getUserJoinedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setUserJoinedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string winner_share_image_url = 28;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string top_five_share_image_url = 29;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getTopFiveShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setTopFiveShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string non_winner_share_image_url = 30;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getNonWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setNonWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional int32 story_length_seconds = 31;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getStoryLengthSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setStoryLengthSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional google.protobuf.Timestamp story_start_time = 32;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getStoryStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 32));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setStoryStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearStoryStartTime = function() {
  return this.setStoryStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasStoryStartTime = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional string share_text = 33;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getShareText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setShareText = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string share_link = 34;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getShareLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setShareLink = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional TransparentAsset transparent_asset = 35;
 * @return {?proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getTransparentAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.TransparentAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.TransparentAsset, 35));
};


/**
 * @param {?proto.buying.auctions.api.v1.TransparentAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setTransparentAsset = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearTransparentAsset = function() {
  return this.setTransparentAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasTransparentAsset = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional int64 reserved_amount_cents = 36;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getReservedAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setReservedAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional google.protobuf.Timestamp pre_registration_time = 38;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getPreRegistrationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 38));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setPreRegistrationTime = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearPreRegistrationTime = function() {
  return this.setPreRegistrationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasPreRegistrationTime = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * repeated int64 max_bid_cap_cents = 39;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMaxBidCapCentsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 39));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMaxBidCapCentsList = function(value) {
  return jspb.Message.setField(this, 39, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addMaxBidCapCents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 39, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearMaxBidCapCentsList = function() {
  return this.setMaxBidCapCentsList([]);
};


/**
 * optional int64 lot_number = 40;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getLotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setLotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional google.protobuf.Timestamp lobby_start_time = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getLobbyStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setLobbyStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearLobbyStartTime = function() {
  return this.setLobbyStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasLobbyStartTime = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional google.protobuf.Timestamp ultimate_end_time = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getUltimateEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setUltimateEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearUltimateEndTime = function() {
  return this.setUltimateEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasUltimateEndTime = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * repeated google.protobuf.Timestamp lobby_round_transition_times = 43;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getLobbyRoundTransitionTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 43));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setLobbyRoundTransitionTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 43, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addLobbyRoundTransitionTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 43, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearLobbyRoundTransitionTimesList = function() {
  return this.setLobbyRoundTransitionTimesList([]);
};


/**
 * optional string product_condition = 44;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getProductCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string product_seller_name = 45;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getProductSellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setProductSellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional google.protobuf.BoolValue is_absentee_auction = 46;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getIsAbsenteeAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 46));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setIsAbsenteeAuction = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearIsAbsenteeAuction = function() {
  return this.setIsAbsenteeAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasIsAbsenteeAuction = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional string brand_name = 47;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional google.protobuf.BoolValue is_published = 48;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getIsPublished = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 48));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setIsPublished = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearIsPublished = function() {
  return this.setIsPublished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasIsPublished = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional google.protobuf.Timestamp event_time = 49;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getEventTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 49));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional int64 min_estimated_value_cents = 50;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMinEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMinEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional int64 max_estimated_value_cents = 51;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getMaxEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setMaxEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * repeated AdpAsset adp_assets = 52;
 * @return {!Array<!proto.buying.auctions.api.v1.AdpAsset>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAdpAssetsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.AdpAsset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.AdpAsset, 52));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.AdpAsset>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAdpAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 52, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.AdpAsset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addAdpAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 52, opt_value, proto.buying.auctions.api.v1.AdpAsset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearAdpAssetsList = function() {
  return this.setAdpAssetsList([]);
};


/**
 * optional string time_expiring_sound_url = 53;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getTimeExpiringSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setTimeExpiringSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * repeated string absentee_auction_product_ids = 54;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAbsenteeAuctionProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 54));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAbsenteeAuctionProductIdsList = function(value) {
  return jspb.Message.setField(this, 54, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addAbsenteeAuctionProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 54, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearAbsenteeAuctionProductIdsList = function() {
  return this.setAbsenteeAuctionProductIdsList([]);
};


/**
 * optional google.protobuf.BoolValue payment_registration_enabled = 55;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getPaymentRegistrationEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 55));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setPaymentRegistrationEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearPaymentRegistrationEnabled = function() {
  return this.setPaymentRegistrationEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasPaymentRegistrationEnabled = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional google.protobuf.BoolValue is_black_friday_auction = 56;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getIsBlackFridayAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 56));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setIsBlackFridayAuction = function(value) {
  return jspb.Message.setWrapperField(this, 56, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearIsBlackFridayAuction = function() {
  return this.setIsBlackFridayAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasIsBlackFridayAuction = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional string segment_id = 57;
 * @return {string}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional int64 threshold_alert_price_cents = 58;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getThresholdAlertPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setThresholdAlertPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 58, value);
};


/**
 * repeated string supported_countries = 59;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getSupportedCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 59));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setSupportedCountriesList = function(value) {
  return jspb.Message.setField(this, 59, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.addSupportedCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 59, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearSupportedCountriesList = function() {
  return this.setSupportedCountriesList([]);
};


/**
 * optional bool is_private = 60;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional google.protobuf.Timestamp registration_end_time = 61;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getRegistrationEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 61));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setRegistrationEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 61, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.clearRegistrationEndTime = function() {
  return this.setRegistrationEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.hasRegistrationEndTime = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional int32 claim_prize_window_minutes = 62;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getClaimPrizeWindowMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setClaimPrizeWindowMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 62, value);
};


/**
 * optional int32 threshold_automatic_bid_removal_price_cents = 63;
 * @return {number}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getThresholdAutomaticBidRemovalPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setThresholdAutomaticBidRemovalPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional bool is_auto_charge_enabled = 64;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getIsAutoChargeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 64, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setIsAutoChargeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 64, value);
};


/**
 * optional AuctionCompletionType auction_completion_type = 65;
 * @return {!proto.buying.auctions.api.v1.AuctionCompletionType}
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.getAuctionCompletionType = function() {
  return /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionCompletionType} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionRequest.prototype.setAuctionCompletionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 65, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.CreateAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.CreateAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.buying.auctions.api.v1.Auction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionResponse}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.CreateAuctionResponse;
  return proto.buying.auctions.api.v1.CreateAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.CreateAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionResponse}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.Auction;
      reader.readMessage(value,proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.CreateAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.CreateAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Auction data = 1;
 * @return {?proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.getData = function() {
  return /** @type{?proto.buying.auctions.api.v1.Auction} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.Auction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.Auction|undefined} value
 * @return {!proto.buying.auctions.api.v1.CreateAuctionResponse} returns this
*/
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.CreateAuctionResponse} returns this
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.CreateAuctionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetAuctionRequest}
 */
proto.buying.auctions.api.v1.GetAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetAuctionRequest;
  return proto.buying.auctions.api.v1.GetAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetAuctionRequest}
 */
proto.buying.auctions.api.v1.GetAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.GetAuctionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.GetAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.GetAuctionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.GetAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.GetAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.buying.auctions.api.v1.Auction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.GetAuctionResponse}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.GetAuctionResponse;
  return proto.buying.auctions.api.v1.GetAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.GetAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.GetAuctionResponse}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.Auction;
      reader.readMessage(value,proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.GetAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.GetAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.GetAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Auction data = 1;
 * @return {?proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.getData = function() {
  return /** @type{?proto.buying.auctions.api.v1.Auction} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.Auction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.Auction|undefined} value
 * @return {!proto.buying.auctions.api.v1.GetAuctionResponse} returns this
*/
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.GetAuctionResponse} returns this
 */
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.GetAuctionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.repeatedFields_ = [3,6,9,39,43,52,54,59];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UpdateAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
preStartTime: (f = msg.getPreStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
roundStartTimesList: jspb.Message.toObjectList(msg.getRoundStartTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
itemFacts: jspb.Message.getFieldWithDefault(msg, 5, ""),
entryTicketsList: jspb.Message.toObjectList(msg.getEntryTicketsList(),
    proto.buying.auctions.api.v1.EntryTickets.toObject, includeInstance),
productId: jspb.Message.getFieldWithDefault(msg, 7, ""),
maximumParticipants: jspb.Message.getFieldWithDefault(msg, 8, 0),
maximumRoundWinnersList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
minimumBidAmountCents: jspb.Message.getFieldWithDefault(msg, 10, 0),
auctionVideoUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
auctionAudioUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
auctionBackgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
auctionAudioTrackUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
itemImageUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
itemVideoUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
item3dAssetUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
userBidSoundUrl: jspb.Message.getFieldWithDefault(msg, 18, ""),
bidSubmittedSoundUrl: jspb.Message.getFieldWithDefault(msg, 19, ""),
productTemplateName: jspb.Message.getFieldWithDefault(msg, 20, ""),
productSizeUs: jspb.Message.getFieldWithDefault(msg, 21, ""),
releaseYear: jspb.Message.getFieldWithDefault(msg, 22, ""),
itemStory: jspb.Message.getFieldWithDefault(msg, 23, ""),
auctionAsset: (f = msg.getAuctionAsset()) && proto.buying.auctions.api.v1.MediaAsset.toObject(includeInstance, f),
estimatedValue: jspb.Message.getFieldWithDefault(msg, 25, ""),
waitingRoomAudioUrl: jspb.Message.getFieldWithDefault(msg, 26, ""),
itemAudioUrl: jspb.Message.getFieldWithDefault(msg, 27, ""),
userJoinedSoundUrl: jspb.Message.getFieldWithDefault(msg, 28, ""),
winnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 29, ""),
topFiveShareImageUrl: jspb.Message.getFieldWithDefault(msg, 30, ""),
nonWinnerShareImageUrl: jspb.Message.getFieldWithDefault(msg, 31, ""),
storyLengthSeconds: jspb.Message.getFieldWithDefault(msg, 32, 0),
storyStartTime: (f = msg.getStoryStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
shareText: jspb.Message.getFieldWithDefault(msg, 34, ""),
shareLink: jspb.Message.getFieldWithDefault(msg, 35, ""),
transparentAsset: (f = msg.getTransparentAsset()) && proto.buying.auctions.api.v1.TransparentAsset.toObject(includeInstance, f),
reservedAmountCents: jspb.Message.getFieldWithDefault(msg, 37, 0),
preRegistrationTime: (f = msg.getPreRegistrationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
maxBidCapCentsList: (f = jspb.Message.getRepeatedField(msg, 39)) == null ? undefined : f,
lotNumber: jspb.Message.getFieldWithDefault(msg, 40, 0),
lobbyStartTime: (f = msg.getLobbyStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
ultimateEndTime: (f = msg.getUltimateEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lobbyRoundTransitionTimesList: jspb.Message.toObjectList(msg.getLobbyRoundTransitionTimesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance),
productCondition: jspb.Message.getFieldWithDefault(msg, 44, ""),
productSellerName: jspb.Message.getFieldWithDefault(msg, 45, ""),
isAbsenteeAuction: (f = msg.getIsAbsenteeAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
brandName: jspb.Message.getFieldWithDefault(msg, 47, ""),
isPublished: (f = msg.getIsPublished()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
eventTime: (f = msg.getEventTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
minEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 50, 0),
maxEstimatedValueCents: jspb.Message.getFieldWithDefault(msg, 51, 0),
adpAssetsList: jspb.Message.toObjectList(msg.getAdpAssetsList(),
    proto.buying.auctions.api.v1.AdpAsset.toObject, includeInstance),
timeExpiringSoundUrl: jspb.Message.getFieldWithDefault(msg, 53, ""),
absenteeAuctionProductIdsList: (f = jspb.Message.getRepeatedField(msg, 54)) == null ? undefined : f,
paymentRegistrationEnabled: (f = msg.getPaymentRegistrationEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
isBlackFridayAuction: (f = msg.getIsBlackFridayAuction()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
segmentId: jspb.Message.getFieldWithDefault(msg, 57, ""),
thresholdAlertPriceCents: jspb.Message.getFieldWithDefault(msg, 58, 0),
supportedCountriesList: (f = jspb.Message.getRepeatedField(msg, 59)) == null ? undefined : f,
isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
registrationEndTime: (f = msg.getRegistrationEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
claimPrizeWindowMinutes: jspb.Message.getFieldWithDefault(msg, 62, 0),
thresholdAutomaticBidRemovalPriceCents: jspb.Message.getFieldWithDefault(msg, 63, 0),
isAutoChargeEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 64, false),
auctionCompletionType: jspb.Message.getFieldWithDefault(msg, 65, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UpdateAuctionRequest;
  return proto.buying.auctions.api.v1.UpdateAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreStartTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addRoundStartTimes(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemFacts(value);
      break;
    case 6:
      var value = new proto.buying.auctions.api.v1.EntryTickets;
      reader.readMessage(value,proto.buying.auctions.api.v1.EntryTickets.deserializeBinaryFromReader);
      msg.addEntryTickets(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaximumParticipants(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaximumRoundWinners(values[i]);
      }
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinimumBidAmountCents(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionVideoUrl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioUrl(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionBackgroundImageUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionAudioTrackUrl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemImageUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemVideoUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem3dAssetUrl(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserBidSoundUrl(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBidSubmittedSoundUrl(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductTemplateName(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSizeUs(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseYear(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemStory(value);
      break;
    case 24:
      var value = new proto.buying.auctions.api.v1.MediaAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.MediaAsset.deserializeBinaryFromReader);
      msg.setAuctionAsset(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatedValue(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaitingRoomAudioUrl(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemAudioUrl(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserJoinedSoundUrl(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setWinnerShareImageUrl(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopFiveShareImageUrl(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonWinnerShareImageUrl(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStoryLengthSeconds(value);
      break;
    case 33:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStoryStartTime(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareText(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareLink(value);
      break;
    case 36:
      var value = new proto.buying.auctions.api.v1.TransparentAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.TransparentAsset.deserializeBinaryFromReader);
      msg.setTransparentAsset(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReservedAmountCents(value);
      break;
    case 38:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPreRegistrationTime(value);
      break;
    case 39:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMaxBidCapCents(values[i]);
      }
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLotNumber(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLobbyStartTime(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUltimateEndTime(value);
      break;
    case 43:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addLobbyRoundTransitionTimes(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCondition(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductSellerName(value);
      break;
    case 46:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsAbsenteeAuction(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandName(value);
      break;
    case 48:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsPublished(value);
      break;
    case 49:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinEstimatedValueCents(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxEstimatedValueCents(value);
      break;
    case 52:
      var value = new proto.buying.auctions.api.v1.AdpAsset;
      reader.readMessage(value,proto.buying.auctions.api.v1.AdpAsset.deserializeBinaryFromReader);
      msg.addAdpAssets(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeExpiringSoundUrl(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.addAbsenteeAuctionProductIds(value);
      break;
    case 55:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPaymentRegistrationEnabled(value);
      break;
    case 56:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsBlackFridayAuction(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setSegmentId(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setThresholdAlertPriceCents(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.addSupportedCountries(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 61:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRegistrationEndTime(value);
      break;
    case 62:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimPrizeWindowMinutes(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThresholdAutomaticBidRemovalPriceCents(value);
      break;
    case 64:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutoChargeEnabled(value);
      break;
    case 65:
      var value = /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (reader.readEnum());
      msg.setAuctionCompletionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UpdateAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRoundStartTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemFacts();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEntryTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.buying.auctions.api.v1.EntryTickets.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMaximumParticipants();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getMaximumRoundWinnersList();
  if (f.length > 0) {
    writer.writePackedInt64(
      9,
      f
    );
  }
  f = message.getMinimumBidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAuctionVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAuctionAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAuctionBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAuctionAudioTrackUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getItemImageUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getItemVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getItem3dAssetUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUserBidSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getBidSubmittedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getProductTemplateName();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getProductSizeUs();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getReleaseYear();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getItemStory();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAuctionAsset();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.buying.auctions.api.v1.MediaAsset.serializeBinaryToWriter
    );
  }
  f = message.getEstimatedValue();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getWaitingRoomAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getItemAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getUserJoinedSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getTopFiveShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getNonWinnerShareImageUrl();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getStoryLengthSeconds();
  if (f !== 0) {
    writer.writeInt32(
      32,
      f
    );
  }
  f = message.getStoryStartTime();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getShareText();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getShareLink();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getTransparentAsset();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      proto.buying.auctions.api.v1.TransparentAsset.serializeBinaryToWriter
    );
  }
  f = message.getReservedAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      37,
      f
    );
  }
  f = message.getPreRegistrationTime();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMaxBidCapCentsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      39,
      f
    );
  }
  f = message.getLotNumber();
  if (f !== 0) {
    writer.writeInt64(
      40,
      f
    );
  }
  f = message.getLobbyStartTime();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUltimateEndTime();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLobbyRoundTransitionTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      43,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductCondition();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getProductSellerName();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getIsAbsenteeAuction();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getBrandName();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getIsPublished();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMinEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      50,
      f
    );
  }
  f = message.getMaxEstimatedValueCents();
  if (f !== 0) {
    writer.writeInt64(
      51,
      f
    );
  }
  f = message.getAdpAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      52,
      f,
      proto.buying.auctions.api.v1.AdpAsset.serializeBinaryToWriter
    );
  }
  f = message.getTimeExpiringSoundUrl();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getAbsenteeAuctionProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      54,
      f
    );
  }
  f = message.getPaymentRegistrationEnabled();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsBlackFridayAuction();
  if (f != null) {
    writer.writeMessage(
      56,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSegmentId();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getThresholdAlertPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      58,
      f
    );
  }
  f = message.getSupportedCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      59,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getRegistrationEndTime();
  if (f != null) {
    writer.writeMessage(
      61,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClaimPrizeWindowMinutes();
  if (f !== 0) {
    writer.writeInt32(
      62,
      f
    );
  }
  f = message.getThresholdAutomaticBidRemovalPriceCents();
  if (f !== 0) {
    writer.writeInt32(
      63,
      f
    );
  }
  f = message.getIsAutoChargeEnabled();
  if (f) {
    writer.writeBool(
      64,
      f
    );
  }
  f = message.getAuctionCompletionType();
  if (f !== 0.0) {
    writer.writeEnum(
      65,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp pre_start_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getPreStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setPreStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearPreStartTime = function() {
  return this.setPreStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasPreStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated google.protobuf.Timestamp round_start_times = 3;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getRoundStartTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setRoundStartTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addRoundStartTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearRoundStartTimesList = function() {
  return this.setRoundStartTimesList([]);
};


/**
 * optional google.protobuf.Timestamp end_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string item_facts = 5;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItemFacts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItemFacts = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated EntryTickets entry_tickets = 6;
 * @return {!Array<!proto.buying.auctions.api.v1.EntryTickets>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getEntryTicketsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.EntryTickets>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.EntryTickets, 6));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.EntryTickets>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setEntryTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.EntryTickets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.EntryTickets}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addEntryTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.buying.auctions.api.v1.EntryTickets, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearEntryTicketsList = function() {
  return this.setEntryTicketsList([]);
};


/**
 * optional string product_id = 7;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 maximum_participants = 8;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMaximumParticipants = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMaximumParticipants = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated int64 maximum_round_winners = 9;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMaximumRoundWinnersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMaximumRoundWinnersList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addMaximumRoundWinners = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearMaximumRoundWinnersList = function() {
  return this.setMaximumRoundWinnersList([]);
};


/**
 * optional int64 minimum_bid_amount_cents = 10;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMinimumBidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMinimumBidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string auction_video_url = 11;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string auction_audio_url = 12;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string auction_background_image_url = 13;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string auction_audio_track_url = 14;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionAudioTrackUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionAudioTrackUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string item_image_url = 15;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItemImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItemImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string item_video_url = 16;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItemVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItemVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string item_3d_asset_url = 17;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItem3dAssetUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItem3dAssetUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string user_bid_sound_url = 18;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getUserBidSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setUserBidSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string bid_submitted_sound_url = 19;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getBidSubmittedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setBidSubmittedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string product_template_name = 20;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getProductTemplateName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setProductTemplateName = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string product_size_us = 21;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getProductSizeUs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setProductSizeUs = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string release_year = 22;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getReleaseYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setReleaseYear = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string item_story = 23;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItemStory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItemStory = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional MediaAsset auction_asset = 24;
 * @return {?proto.buying.auctions.api.v1.MediaAsset}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.MediaAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.MediaAsset, 24));
};


/**
 * @param {?proto.buying.auctions.api.v1.MediaAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionAsset = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearAuctionAsset = function() {
  return this.setAuctionAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasAuctionAsset = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string estimated_value = 25;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getEstimatedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setEstimatedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string waiting_room_audio_url = 26;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getWaitingRoomAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setWaitingRoomAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string item_audio_url = 27;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getItemAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setItemAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string user_joined_sound_url = 28;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getUserJoinedSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setUserJoinedSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string winner_share_image_url = 29;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string top_five_share_image_url = 30;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getTopFiveShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setTopFiveShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string non_winner_share_image_url = 31;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getNonWinnerShareImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setNonWinnerShareImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int32 story_length_seconds = 32;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getStoryLengthSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setStoryLengthSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional google.protobuf.Timestamp story_start_time = 33;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getStoryStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 33));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setStoryStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearStoryStartTime = function() {
  return this.setStoryStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasStoryStartTime = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional string share_text = 34;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getShareText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setShareText = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string share_link = 35;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getShareLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setShareLink = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional TransparentAsset transparent_asset = 36;
 * @return {?proto.buying.auctions.api.v1.TransparentAsset}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getTransparentAsset = function() {
  return /** @type{?proto.buying.auctions.api.v1.TransparentAsset} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.TransparentAsset, 36));
};


/**
 * @param {?proto.buying.auctions.api.v1.TransparentAsset|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setTransparentAsset = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearTransparentAsset = function() {
  return this.setTransparentAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasTransparentAsset = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional int64 reserved_amount_cents = 37;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getReservedAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setReservedAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional google.protobuf.Timestamp pre_registration_time = 38;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getPreRegistrationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 38));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setPreRegistrationTime = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearPreRegistrationTime = function() {
  return this.setPreRegistrationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasPreRegistrationTime = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * repeated int64 max_bid_cap_cents = 39;
 * @return {!Array<number>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMaxBidCapCentsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 39));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMaxBidCapCentsList = function(value) {
  return jspb.Message.setField(this, 39, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addMaxBidCapCents = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 39, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearMaxBidCapCentsList = function() {
  return this.setMaxBidCapCentsList([]);
};


/**
 * optional int64 lot_number = 40;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getLotNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setLotNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional google.protobuf.Timestamp lobby_start_time = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getLobbyStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setLobbyStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearLobbyStartTime = function() {
  return this.setLobbyStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasLobbyStartTime = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional google.protobuf.Timestamp ultimate_end_time = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getUltimateEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setUltimateEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearUltimateEndTime = function() {
  return this.setUltimateEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasUltimateEndTime = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * repeated google.protobuf.Timestamp lobby_round_transition_times = 43;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getLobbyRoundTransitionTimesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 43));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setLobbyRoundTransitionTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 43, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addLobbyRoundTransitionTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 43, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearLobbyRoundTransitionTimesList = function() {
  return this.setLobbyRoundTransitionTimesList([]);
};


/**
 * optional string product_condition = 44;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getProductCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setProductCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string product_seller_name = 45;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getProductSellerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setProductSellerName = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional google.protobuf.BoolValue is_absentee_auction = 46;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getIsAbsenteeAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 46));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setIsAbsenteeAuction = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearIsAbsenteeAuction = function() {
  return this.setIsAbsenteeAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasIsAbsenteeAuction = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional string brand_name = 47;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getBrandName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setBrandName = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional google.protobuf.BoolValue is_published = 48;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getIsPublished = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 48));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setIsPublished = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearIsPublished = function() {
  return this.setIsPublished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasIsPublished = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional google.protobuf.Timestamp event_time = 49;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getEventTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 49));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional int64 min_estimated_value_cents = 50;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMinEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMinEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional int64 max_estimated_value_cents = 51;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getMaxEstimatedValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setMaxEstimatedValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * repeated AdpAsset adp_assets = 52;
 * @return {!Array<!proto.buying.auctions.api.v1.AdpAsset>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAdpAssetsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.AdpAsset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.AdpAsset, 52));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.AdpAsset>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAdpAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 52, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.AdpAsset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.AdpAsset}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addAdpAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 52, opt_value, proto.buying.auctions.api.v1.AdpAsset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearAdpAssetsList = function() {
  return this.setAdpAssetsList([]);
};


/**
 * optional string time_expiring_sound_url = 53;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getTimeExpiringSoundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setTimeExpiringSoundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * repeated string absentee_auction_product_ids = 54;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAbsenteeAuctionProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 54));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAbsenteeAuctionProductIdsList = function(value) {
  return jspb.Message.setField(this, 54, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addAbsenteeAuctionProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 54, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearAbsenteeAuctionProductIdsList = function() {
  return this.setAbsenteeAuctionProductIdsList([]);
};


/**
 * optional google.protobuf.BoolValue payment_registration_enabled = 55;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getPaymentRegistrationEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 55));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setPaymentRegistrationEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearPaymentRegistrationEnabled = function() {
  return this.setPaymentRegistrationEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasPaymentRegistrationEnabled = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional google.protobuf.BoolValue is_black_friday_auction = 56;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getIsBlackFridayAuction = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 56));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setIsBlackFridayAuction = function(value) {
  return jspb.Message.setWrapperField(this, 56, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearIsBlackFridayAuction = function() {
  return this.setIsBlackFridayAuction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasIsBlackFridayAuction = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional string segment_id = 57;
 * @return {string}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional int64 threshold_alert_price_cents = 58;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getThresholdAlertPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setThresholdAlertPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 58, value);
};


/**
 * repeated string supported_countries = 59;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getSupportedCountriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 59));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setSupportedCountriesList = function(value) {
  return jspb.Message.setField(this, 59, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.addSupportedCountries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 59, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearSupportedCountriesList = function() {
  return this.setSupportedCountriesList([]);
};


/**
 * optional bool is_private = 60;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional google.protobuf.Timestamp registration_end_time = 61;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getRegistrationEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 61));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setRegistrationEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 61, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.clearRegistrationEndTime = function() {
  return this.setRegistrationEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.hasRegistrationEndTime = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional int32 claim_prize_window_minutes = 62;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getClaimPrizeWindowMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setClaimPrizeWindowMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 62, value);
};


/**
 * optional int32 threshold_automatic_bid_removal_price_cents = 63;
 * @return {number}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getThresholdAutomaticBidRemovalPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setThresholdAutomaticBidRemovalPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional bool is_auto_charge_enabled = 64;
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getIsAutoChargeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 64, false));
};


/**
 * @param {boolean} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setIsAutoChargeEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 64, value);
};


/**
 * optional AuctionCompletionType auction_completion_type = 65;
 * @return {!proto.buying.auctions.api.v1.AuctionCompletionType}
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.getAuctionCompletionType = function() {
  return /** @type {!proto.buying.auctions.api.v1.AuctionCompletionType} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionCompletionType} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionRequest.prototype.setAuctionCompletionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 65, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UpdateAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.buying.auctions.api.v1.Auction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionResponse}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UpdateAuctionResponse;
  return proto.buying.auctions.api.v1.UpdateAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionResponse}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.Auction;
      reader.readMessage(value,proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UpdateAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UpdateAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Auction data = 1;
 * @return {?proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.getData = function() {
  return /** @type{?proto.buying.auctions.api.v1.Auction} */ (
    jspb.Message.getWrapperField(this, proto.buying.auctions.api.v1.Auction, 1));
};


/**
 * @param {?proto.buying.auctions.api.v1.Auction|undefined} value
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionResponse} returns this
*/
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.buying.auctions.api.v1.UpdateAuctionResponse} returns this
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.buying.auctions.api.v1.UpdateAuctionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.DeleteAuctionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.DeleteAuctionRequest}
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.DeleteAuctionRequest;
  return proto.buying.auctions.api.v1.DeleteAuctionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.DeleteAuctionRequest}
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.DeleteAuctionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.DeleteAuctionRequest} returns this
 */
proto.buying.auctions.api.v1.DeleteAuctionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.DeleteAuctionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.DeleteAuctionResponse}
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.DeleteAuctionResponse;
  return proto.buying.auctions.api.v1.DeleteAuctionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.DeleteAuctionResponse}
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.DeleteAuctionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.DeleteAuctionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.DeleteAuctionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListAuctionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListAuctionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
paginationToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListAuctionsRequest}
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListAuctionsRequest;
  return proto.buying.auctions.api.v1.ListAuctionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListAuctionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListAuctionsRequest}
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListAuctionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListAuctionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string pagination_token = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionsRequest} returns this
 */
proto.buying.auctions.api.v1.ListAuctionsRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListAuctionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListAuctionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.buying.auctions.api.v1.Auction.toObject, includeInstance),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListAuctionsResponse}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListAuctionsResponse;
  return proto.buying.auctions.api.v1.ListAuctionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListAuctionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListAuctionsResponse}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.Auction;
      reader.readMessage(value,proto.buying.auctions.api.v1.Auction.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListAuctionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListAuctionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.auctions.api.v1.Auction.serializeBinaryToWriter
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Auction data = 1;
 * @return {!Array<!proto.buying.auctions.api.v1.Auction>}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.Auction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.Auction, 1));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.Auction>} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionsResponse} returns this
*/
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.Auction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.Auction}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.auctions.api.v1.Auction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.ListAuctionsResponse} returns this
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionsResponse} returns this
 */
proto.buying.auctions.api.v1.ListAuctionsResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ClearAuctionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ClearAuctionsRequest}
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ClearAuctionsRequest;
  return proto.buying.auctions.api.v1.ClearAuctionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ClearAuctionsRequest}
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ClearAuctionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ClearAuctionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ClearAuctionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ClearAuctionsResponse}
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ClearAuctionsResponse;
  return proto.buying.auctions.api.v1.ClearAuctionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ClearAuctionsResponse}
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ClearAuctionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ClearAuctionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ClearAuctionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.MarkBidderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.MarkBidderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MarkBidderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.MarkBidderRequest}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.MarkBidderRequest;
  return proto.buying.auctions.api.v1.MarkBidderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.MarkBidderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.MarkBidderRequest}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.MarkBidderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.MarkBidderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MarkBidderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.MarkBidderRequest} returns this
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.MarkBidderRequest} returns this
 */
proto.buying.auctions.api.v1.MarkBidderRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.MarkBidderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.MarkBidderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.MarkBidderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MarkBidderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.MarkBidderResponse}
 */
proto.buying.auctions.api.v1.MarkBidderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.MarkBidderResponse;
  return proto.buying.auctions.api.v1.MarkBidderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.MarkBidderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.MarkBidderResponse}
 */
proto.buying.auctions.api.v1.MarkBidderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.MarkBidderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.MarkBidderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.MarkBidderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.MarkBidderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UnmarkBidderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UnmarkBidderRequest}
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UnmarkBidderRequest;
  return proto.buying.auctions.api.v1.UnmarkBidderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UnmarkBidderRequest}
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UnmarkBidderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.UnmarkBidderRequest} returns this
 */
proto.buying.auctions.api.v1.UnmarkBidderRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.UnmarkBidderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.UnmarkBidderResponse}
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.UnmarkBidderResponse;
  return proto.buying.auctions.api.v1.UnmarkBidderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.UnmarkBidderResponse}
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.UnmarkBidderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.UnmarkBidderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.UnmarkBidderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListMarkedBiddersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListMarkedBiddersRequest;
  return proto.buying.auctions.api.v1.ListMarkedBiddersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListMarkedBiddersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersRequest} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListMarkedBiddersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListMarkedBiddersResponse;
  return proto.buying.auctions.api.v1.ListMarkedBiddersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListMarkedBiddersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListMarkedBiddersResponse} returns this
 */
proto.buying.auctions.api.v1.ListMarkedBiddersResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.WinnerPrize.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.WinnerPrize} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.WinnerPrize.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
productId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.WinnerPrize}
 */
proto.buying.auctions.api.v1.WinnerPrize.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.WinnerPrize;
  return proto.buying.auctions.api.v1.WinnerPrize.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.WinnerPrize} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.WinnerPrize}
 */
proto.buying.auctions.api.v1.WinnerPrize.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.WinnerPrize.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.WinnerPrize} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.WinnerPrize.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.WinnerPrize} returns this
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_id = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.WinnerPrize} returns this
 */
proto.buying.auctions.api.v1.WinnerPrize.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ProcessWinnersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
prizesList: jspb.Message.toObjectList(msg.getPrizesList(),
    proto.buying.auctions.api.v1.WinnerPrize.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ProcessWinnersRequest;
  return proto.buying.auctions.api.v1.ProcessWinnersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 3:
      var value = new proto.buying.auctions.api.v1.WinnerPrize;
      reader.readMessage(value,proto.buying.auctions.api.v1.WinnerPrize.deserializeBinaryFromReader);
      msg.addPrizes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ProcessWinnersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPrizesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.buying.auctions.api.v1.WinnerPrize.serializeBinaryToWriter
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string user_ids = 2;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated WinnerPrize prizes = 3;
 * @return {!Array<!proto.buying.auctions.api.v1.WinnerPrize>}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.getPrizesList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.WinnerPrize>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.WinnerPrize, 3));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.WinnerPrize>} value
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
*/
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.setPrizesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.WinnerPrize=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.WinnerPrize}
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.addPrizes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.buying.auctions.api.v1.WinnerPrize, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersRequest} returns this
 */
proto.buying.auctions.api.v1.ProcessWinnersRequest.prototype.clearPrizesList = function() {
  return this.setPrizesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ProcessWinnersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersResponse}
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ProcessWinnersResponse;
  return proto.buying.auctions.api.v1.ProcessWinnersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ProcessWinnersResponse}
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ProcessWinnersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ProcessWinnersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ProcessWinnersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
approvalStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest;
  return proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (reader.readEnum());
      msg.setApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string user_ids = 2;
 * @return {!Array<string>}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * optional ApprovalStatus approval_status = 3;
 * @return {!proto.buying.auctions.api.v1.ApprovalStatus}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.getApprovalStatus = function() {
  return /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.ApprovalStatus} value
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusRequest.prototype.setApprovalStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse;
  return proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.BatchSetApprovalStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.SetApprovalStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
approvalStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusRequest}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.SetApprovalStatusRequest;
  return proto.buying.auctions.api.v1.SetApprovalStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusRequest}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (reader.readEnum());
      msg.setApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.SetApprovalStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ApprovalStatus approval_status = 3;
 * @return {!proto.buying.auctions.api.v1.ApprovalStatus}
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.getApprovalStatus = function() {
  return /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.ApprovalStatus} value
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusRequest} returns this
 */
proto.buying.auctions.api.v1.SetApprovalStatusRequest.prototype.setApprovalStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.SetApprovalStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusResponse}
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.SetApprovalStatusResponse;
  return proto.buying.auctions.api.v1.SetApprovalStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.SetApprovalStatusResponse}
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.SetApprovalStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.SetApprovalStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.SetApprovalStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.AuctionApplicant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.AuctionApplicant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.AuctionApplicant.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
approvalStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.AuctionApplicant}
 */
proto.buying.auctions.api.v1.AuctionApplicant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.AuctionApplicant;
  return proto.buying.auctions.api.v1.AuctionApplicant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.AuctionApplicant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.AuctionApplicant}
 */
proto.buying.auctions.api.v1.AuctionApplicant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (reader.readEnum());
      msg.setApprovalStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.AuctionApplicant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.AuctionApplicant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.AuctionApplicant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApprovalStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.AuctionApplicant} returns this
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ApprovalStatus approval_status = 2;
 * @return {!proto.buying.auctions.api.v1.ApprovalStatus}
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.getApprovalStatus = function() {
  return /** @type {!proto.buying.auctions.api.v1.ApprovalStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.buying.auctions.api.v1.ApprovalStatus} value
 * @return {!proto.buying.auctions.api.v1.AuctionApplicant} returns this
 */
proto.buying.auctions.api.v1.AuctionApplicant.prototype.setApprovalStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
auctionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListAuctionApplicantsRequest;
  return proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuctionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuctionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string auction_id = 1;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.getAuctionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} returns this
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.setAuctionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} returns this
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsRequest} returns this
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
applicationsList: jspb.Message.toObjectList(msg.getApplicationsList(),
    proto.buying.auctions.api.v1.AuctionApplicant.toObject, includeInstance),
paginationToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.buying.auctions.api.v1.ListAuctionApplicantsResponse;
  return proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.buying.auctions.api.v1.AuctionApplicant;
      reader.readMessage(value,proto.buying.auctions.api.v1.AuctionApplicant.deserializeBinaryFromReader);
      msg.addApplications(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.buying.auctions.api.v1.AuctionApplicant.serializeBinaryToWriter
    );
  }
  f = message.getPaginationToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated AuctionApplicant applications = 1;
 * @return {!Array<!proto.buying.auctions.api.v1.AuctionApplicant>}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.getApplicationsList = function() {
  return /** @type{!Array<!proto.buying.auctions.api.v1.AuctionApplicant>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.buying.auctions.api.v1.AuctionApplicant, 1));
};


/**
 * @param {!Array<!proto.buying.auctions.api.v1.AuctionApplicant>} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} returns this
*/
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.setApplicationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.buying.auctions.api.v1.AuctionApplicant=} opt_value
 * @param {number=} opt_index
 * @return {!proto.buying.auctions.api.v1.AuctionApplicant}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.addApplications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.buying.auctions.api.v1.AuctionApplicant, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} returns this
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.clearApplicationsList = function() {
  return this.setApplicationsList([]);
};


/**
 * optional string pagination_token = 2;
 * @return {string}
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.getPaginationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.buying.auctions.api.v1.ListAuctionApplicantsResponse} returns this
 */
proto.buying.auctions.api.v1.ListAuctionApplicantsResponse.prototype.setPaginationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.AuctionState = {
  AUCTION_STATE_INVALID: 0,
  AUCTION_STATE_PENDING: 1,
  AUCTION_STATE_OPEN: 2,
  AUCTION_STATE_CLOSED: 3
};

/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.AuctionCompletionType = {
  AUCTION_COMPLETION_TYPE_INVALID: 0,
  AUCTION_COMPLETION_TYPE_MANUAL_WINNER_SELECTION: 1,
  AUCTION_COMPLETION_TYPE_AUTO_ASSIGN_WINNER: 2
};

/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.AdpAssetType = {
  ADP_ASSET_TYPE_INVALID: 0,
  ADP_ASSET_TYPE_IMAGE: 1,
  ADP_ASSET_TYPE_MP4_VIDEO: 2,
  ADP_ASSET_TYPE_3D_MODEL: 3,
  ADP_ASSET_TYPE_TRANSPARENT_VIDEO: 4
};

/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.ApprovalStatus = {
  APPROVAL_STATUS_INVALID: 0,
  APPROVAL_STATUS_PENDING: 1,
  APPROVAL_STATUS_APPROVED: 2,
  APPROVAL_STATUS_DENIED: 3
};

/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.PrizeStatus = {
  PRIZE_STATUS_INVALID: 0,
  PRIZE_STATUS_UNCLAIMED: 1,
  PRIZE_STATUS_CLAIMED: 2
};

/**
 * @enum {number}
 */
proto.buying.auctions.api.v1.AuctionEventType = {
  AUCTION_EVENT_TYPE_INVALID: 0,
  AUCTION_EVENT_TYPE_ALL: 1,
  AUCTION_EVENT_TYPE_BLACK_FRIDAY: 2,
  AUCTION_EVENT_TYPE_EVERGREEN: 3
};

goog.object.extend(exports, proto.buying.auctions.api.v1);
